{
  "account.account": "Profil och säkerhet",
  "account.accountDeleted": "Ditt konto har raderats.",
  "account.accountDescription": "Namn, lösenord, radera konto",
  "account.accountSection": "Konto",
  "account.changeEmail": "Ändra e-post",
  "account.changePassword": "Byt lösenord",
  "account.currentPassword": "Nuvarande lösenord",
  "account.dangerZone": "Riskzon",
  "account.deleteAccount": "Radera konto",
  "account.deleteAccountConfirmation": "Är du säker på att du vill ta bort ditt konto? Denna åtgärd är oåterkallelig.",
  "account.deleteAccountDescription": "Denna åtgärd raderar ditt konto och all din information. Det finns ingen väg tillbaka.",
  "account.emailChange": "Ändra e-postadress",
  "account.emailChangeConfirmation": "Bekräftelse av e-poständring",
  "account.emailChangeFailure": "Länken för e-poständring är ogiltig eller har gått ut.",
  "account.emailChangeIntro": "Ange din nya e-postadress och ditt nuvarande lösenord. Vi skickar en länk till den nya adressen: din e-postadress ändras först när du öppnar den.",
  "account.emailChangeSuccess": "Din e-post har ändrats till {newEmail}.",
  "account.emailChangeSuccessNoAddress": "Din e-postadress har ändrats.",
  "account.emailChangeVerificationSent": "Ett verifieringsmeddelande har skickats till din nya e-postadress. Kontrollera din inkorg och klicka på länken för att bekräfta ändringen.",
  "account.manageAccount": "Hantera konto",
  "account.newEmailAddress": "Ny e-postadress",
  "account.newPassword": "Nytt lösenord",
  "account.newPasswordAgain": "Nytt lösenord (igen)",
  "account.oldPassword": "Gammalt lösenord",
  "account.passwordChange": "Lösenordsbyte",
  "account.passwordChangeDescription": "Håll ditt konto säkert",
  "account.passwordUpdated": "Lösenord har uppdaterats.",
  "account.profile": "Profil",
  "account.profileUpdated": "Profilen har uppdaterats.",
  "account.signedInAs": "Inloggad som",
  "account.updateYourProfile": "Uppdatera din profil",
  "account.updateYourProfileDescription": "Namn och visningsinställningar",
  "addons.accountOnHold": "Din kontoanslutning har löpt ut. Anslut igen för att återuppta datauppdateringar.",
  "addons.accountOnHoldTitle": "Konto pausat",
  "addons.ambientWeatherCreateAndRetrieveApiKey": "Skapa och hämta din API-nyckel från den här länken",
  "addons.ambientWeatherDescription": "Ambient Weather väderstationer (WS-5000, WS-2000, WS-2902C,...)",
  "addons.apiKey": "API-nyckel",
  "addons.applicationKey": "Applikationsnyckel",
  "addons.availableServices": "Tillgängliga",
  "addons.cannotDisconnectLastAccount": "Kan inte koppla från din enda inloggningsmetod. Lägg till en annan inloggningsmetod först.",
  "addons.connect": "Anslut",
  "addons.connected": "Ansluten",
  "addons.connectedAccounts": "Anslutna konton",
  "addons.connectedAccountsDescription": "Apple, Google, Facebook",
  "addons.connectedAccountsLoading": "Läser in anslutna konton…",
  "addons.connectedServices": "Anslutna",
  "addons.connectedSince": "Ansluten sedan {date}",
  "addons.connectionSection": "Anslutning",
  "addons.connectionSuccess": "{provider}-konto anslutet",
  "addons.davisApiSecret": "API-hemlighet",
  "addons.davisApiV2Key": "API-nyckel V2",
  "addons.davisDescription": "Davis väderstationer (Vantage Vue, Vantage Pro2,...)",
  "addons.davisRetrieveApiKey": "Hämta dina V2 API-nycklar från den här länken",
  "addons.disconnect": "Koppla från",
  "addons.disconnectConfirmation": "Är du säker på att du vill koppla från ditt {provider}-konto?",
  "addons.disconnectEnergyConfirmation": "SmartMixin slutar synkronisera Netatmo Energy och tar bort dina hem från SmartMixin. Ditt Netatmo-konto och dina enheter påverkas inte.",
  "addons.disconnectEnergyDescription": "Stoppar synkroniseringen och tar bort dina hem från SmartMixin.",
  "addons.disconnectionSuccess": "{provider}-konto frånkopplat",
  "addons.disconnectProviderDescription": "Stoppar synkroniseringen och raderar tjänstens stationer och deras historik.",
  "addons.disconnectServiceConfirmation": "SmartMixin slutar synkronisera {provider} och raderar tjänstens stationer och hela deras historik. Själva ditt {provider}-konto påverkas inte.",
  "addons.disconnectServiceTitle": "Koppla från {provider}?",
  "addons.ecowittCreateAndRetrieveKeys": "Skapa och hämta din API-nyckel och appnyckel från den här länken",
  "addons.ecowittDescription": "Ecowitt tillhandahåller professionella väderstationer, trådlösa inomhus- och utomhustermometrar, högprecisionsregnmätare, luftkvalitetssensorer och mycket mer.",
  "addons.helpLink": "Så här ansluter du {provider}",
  "addons.integrationsSection": "Integrationer",
  "addons.myAcuriteAccountOnHold": "Ditt konto har pausats. Ange ditt lösenord för att återansluta ditt konto",
  "addons.myAcuriteDescription": "AcuRite är det #1 väderstationsvarumärket i Nordamerika. Som ledare inom tid-, temperatur- och väderteknologi ger AcuRite dig detaljerad information om din inomhus- och utomhusmiljö så att du kan planera din dag med tillförsikt.",
  "addons.netatmoEnergy": "Netatmo Energy",
  "addons.netatmoEnergyDescription": "Använd din Netatmo-termostat för att ändra temperaturen i hemmet, från din säng eller från andra sidan världen.",
  "addons.netatmoWeather": "Netatmo Weather",
  "addons.netatmoWeatherDescription": "Din personliga väderstation hemma",
  "addons.notConnected": "Inte ansluten",
  "addons.or": "eller",
  "addons.providerAccountDisconnected": "Anslutningen till din vädertjänst har löpt ut. Anslut igen för att återuppta datauppdateringar.",
  "addons.reconnect": "Återanslut",
  "addons.socialConnectionsIntro": "Länka dina sociala konton för snabb inloggning. Du kan ansluta eller koppla från konton när som helst.",
  "addons.weatherflowAccessToken": "Åtkomsttoken",
  "addons.weatherflowCreateToken": "Skapa och hämta din token från den här länken",
  "addons.weatherflowTempestDescription": "Tempest vädersystem med inbyggd vindmätare och regnmätare",
  "addons.weatherServices": "Vädertjänster",
  "addons.weatherServicesConnected": "{count, plural, =0 {Inga tjänster anslutna} one {# tjänst ansluten} other {# tjänster anslutna}}",
  "addons.weatherServicesDescription": "Anslut Netatmo, Davis, Weatherflow och fler",
  "addons.wundergroundApiKey": "API-nyckel",
  "addons.wundergroundDescription": "Weather Underground är en global gemenskap av människor som ansluter data från miljösensorer som väderstationer och luftkvalitetsmonitorer så att vi kan leverera den rika, hyperlokala informationen du behöver för att driva dina passioner.",
  "addons.wundergroundRemoveStationDescription": "Stationen tas bort från ditt SmartMixin-konto. Om inte ett annat SmartMixin-konto också har lagt till den raderas stationen och den historik SmartMixin har registrerat för den. Inget ändras på Weather Underground.",
  "addons.wundergroundRemoveStationTitle": "Radera {station}?",
  "addons.wundergroundRetrieveApiKey": "Hämta din API-nyckel från den här länken",
  "addons.wundergroundStationId": "Stations-ID",
  "airQuality.adviceActivityGood": "En perfekt dag för aktiviteter utomhus",
  "airQuality.adviceActivityHazardous": "Undvik all fysisk aktivitet utomhus",
  "airQuality.adviceActivityLabel": "Fysisk aktivitet",
  "airQuality.adviceActivityModerate": "En bra dag för aktiviteter utomhus",
  "airQuality.adviceActivitySensitive": "Överväg kortare och mindre intensiva aktiviteter utomhus",
  "airQuality.adviceActivityUnhealthy": "Minska långa eller intensiva aktiviteter och ta fler pauser",
  "airQuality.adviceActivityVeryUnhealthy": "Undvik långa eller intensiva aktiviteter; överväg att flytta dem inomhus",
  "airQuality.adviceGroupsGood": "Inga särskilda försiktighetsåtgärder behövs",
  "airQuality.adviceGroupsHazardous": "Stanna inomhus och håll aktivitetsnivån låg",
  "airQuality.adviceGroupsLabel": "Känsliga grupper",
  "airQuality.adviceGroupsModerate": "Särskilt känsliga personer: kortare och mindre intensiva aktiviteter",
  "airQuality.adviceGroupsSensitive": "Gör aktiviteter utomhus kortare och mindre intensiva och ta fler pauser",
  "airQuality.adviceGroupsUnhealthy": "Undvik långa eller intensiva aktiviteter utomhus; överväg att flytta dem inomhus",
  "airQuality.adviceGroupsVeryUnhealthy": "Undvik all fysisk aktivitet utomhus; skjut upp den eller flytta den inomhus",
  "airQuality.adviceTimingLabel": "När du bör gå ut",
  "airQuality.adviceTimingMorning": "Helst på förmiddagen – då är ozonhalten lägre",
  "airQuality.airQuality": "Luftkvalitet",
  "airQuality.airQualityIndex": "Luftkvalitetsindex",
  "airQuality.aqiForecast": "Prognos för luftkvalitet",
  "airQuality.co2Fresh": "Frisk",
  "airQuality.co2GettingStale": "Lite kvavt",
  "airQuality.co2Stale": "Kvavt",
  "airQuality.dailyForecast": "Daglig prognos",
  "airQuality.dominantPollutant": "Dominerande förorening",
  "airQuality.expectedPeak": "Förväntad topp",
  "airQuality.good": "Bra",
  "airQuality.goodDescription": "Luftkvaliteten är tillfredsställande och risken för föroreningar anses lite eller obefintlig",
  "airQuality.hazardous": "Farlig",
  "airQuality.hazardousDescription": "Hälsovarning: Vem som helst kan uppleva allvarligare hälsoeffekter.",
  "airQuality.indoorAirQuality": "Luftkvalitet inomhus",
  "airQuality.moderate": "Måttlig",
  "airQuality.moderateDescription": "Luftkvaliteten är acceptabel. Men för vissa typer av föroreningar kan det finnas ett måttligt hälsoproblem för ett mycket litet antal människor som är överkänsliga för luftföroreningar.",
  "airQuality.noForecastForLocation": "Ingen luftkvalitetsprognos finns för den här platsen.",
  "airQuality.now": "Nu",
  "airQuality.nowCastAqi": "NowCast AQI",
  "airQuality.pollutants": "Föroreningar",
  "airQuality.recommendations": "Rekommendationer",
  "airQuality.sensitiveUnhealthy": "Ohälsosam för känsliga grupper",
  "airQuality.sensitiveUnhealthyDescription": "Känsliga personer kan uppleva hälsoeffekter. De flesta kommer sannolikt inte att påverkas.",
  "airQuality.subIndex": "AQI-delindex",
  "airQuality.ugm3": "µg/m³",
  "airQuality.understandIndex": "Förstå indexet",
  "airQuality.unhealthy": "Ohälsosam",
  "airQuality.unhealthyDescription": "Alla kan uppleva hälsoeffekter; känsliga personer kan uppleva allvarligare hälsoeffekter",
  "airQuality.veryUnhealthy": "Mycket ohälsosam",
  "airQuality.veryUnhealthyDescription": "Varningar om nödsituationer. Det är sannolikt att hela befolkningen påverkas.",
  "alerts.addAlert": "Lägg till en varning",
  "alerts.addCondition": "Lägg till villkor",
  "alerts.alertAdded": "Varningen har lagts till",
  "alerts.alertAuthorizationNotice": "Varningar kan bara fungera om du tillåter SmartMixin att visa aviseringar",
  "alerts.alertDeleted": "Varningen har tagits bort",
  "alerts.alertName": "Varningsnamn",
  "alerts.alertWhen": "Jag vill bli varnad när:",
  "alerts.aqiGreaterThan": "AQI större än",
  "alerts.aqiGreaterThanThreshold": "AQI över tröskeln {value}{unit}",
  "alerts.aqiLessThan": "AQI mindre än",
  "alerts.aqiLessThanThreshold": "AQI under tröskelvärdet {value}{unit}",
  "alerts.atLeastOneCondition": "Du måste lägga till minst ett villkor",
  "alerts.co2GreaterThan": "CO2 större än",
  "alerts.co2GreaterThanThreshold": "CO2 över tröskelvärdet {value}{unit}",
  "alerts.co2LessThan": "CO2 mindre än",
  "alerts.co2LessThanThreshold": "CO2 under tröskelvärdet {value}{unit}",
  "alerts.conditions": "Villkor",
  "alerts.conditionsDroppedOnStationChange": "Stöds inte av den här stationen och har tagits bort: {conditions}",
  "alerts.createAlert": "Skapa varning",
  "alerts.dailyPrecipitationGreaterThan": "Dygnsnederbörd större än",
  "alerts.dailyPrecipitationGreaterThanThreshold": "Dygnsnederbörd över tröskelvärdet {value}{unit}",
  "alerts.deleteAlert": "Ta bort varning",
  "alerts.editAlert": "Redigera varning",
  "alerts.editCondition": "Ändra villkor",
  "alerts.gustSpeedGreaterThan": "Vindbyar större än",
  "alerts.gustSpeedGreaterThanThreshold": "Vindbyar över tröskelvärdet {value}{unit}",
  "alerts.gustSpeedLessThan": "Vindbyar mindre än",
  "alerts.gustSpeedLessThanThreshold": "Vindbyar under tröskelvärdet {value}{unit}",
  "alerts.heatIndexGreaterThan": "Värmeindex större än",
  "alerts.heatIndexGreaterThanThreshold": "Värmeindex över tröskelvärdet {value}{unit}",
  "alerts.heatIndexLessThan": "Värmeindex mindre än",
  "alerts.heatIndexLessThanThreshold": "Värmeindex under tröskelvärdet {value}{unit}",
  "alerts.humidexGreaterThan": "Fuktindex större än",
  "alerts.humidexGreaterThanThreshold": "Fuktindex över tröskelvärdet {value}{unit}",
  "alerts.humidexLessThan": "Fuktindex mindre än",
  "alerts.humidexLessThanThreshold": "Fuktindex under tröskelvärdet {value}{unit}",
  "alerts.humidityGreaterThan": "Luftfuktighet över",
  "alerts.humidityGreaterThanThreshold": "Fuktighet över tröskelvärdet {value}{unit}",
  "alerts.humidityLessThan": "Luftfuktighet under",
  "alerts.humidityLessThanThreshold": "Fuktighet under tröskelvärdet {value}{unit}",
  "alerts.inProgress": "Pågående",
  "alerts.leafWetnessGreaterThan": "Bladvåthet över",
  "alerts.leafWetnessGreaterThanThreshold": "Bladvåthet över tröskelvärdet {value}{unit}",
  "alerts.leafWetnessLessThan": "Bladvåthet under",
  "alerts.leafWetnessLessThanThreshold": "Bladvåthet under tröskelvärdet {value}{unit}",
  "alerts.myAlerts": "Mina varningar",
  "alerts.noConfiguredAlert": "Du har ingen avisering än, lägg till en",
  "alerts.noiseGreaterThan": "Buller större än",
  "alerts.noiseGreaterThanThreshold": "Buller över tröskelvärdet {value}{unit}",
  "alerts.noiseLessThan": "Buller mindre än",
  "alerts.noiseLessThanThreshold": "Buller under tröskelvärdet {value}{unit}",
  "alerts.noteOnConditions": "Observera att varningen utlöses när alla villkor nedan är verifierade",
  "alerts.noTriggerHistory": "Det här larmet har inte utlösts ännu.",
  "alerts.pm10GreaterThan": "PM 10 större än",
  "alerts.pm10GreaterThanThreshold": "PM 10 över tröskeln {value}{unit}",
  "alerts.pm10LessThan": "PM 10 mindre än",
  "alerts.pm10LessThanThreshold": "PM 10 under tröskelvärdet {value}{unit}",
  "alerts.pm1GreaterThan": "PM 1 större än",
  "alerts.pm1GreaterThanThreshold": "PM 1 över tröskeln {value}{unit}",
  "alerts.pm1LessThan": "PM 1 mindre än",
  "alerts.pm1LessThanThreshold": "PM 1 under tröskelvärdet {value}{unit}",
  "alerts.pm2p5GreaterThan": "PM 2,5 större än",
  "alerts.pm2p5GreaterThanThreshold": "PM 2,5 över tröskelvärdet {value}{unit}",
  "alerts.pm2p5LessThan": "PM 2,5 mindre än",
  "alerts.pm2p5LessThanThreshold": "PM 2,5 under tröskelvärdet för {value}{unit}",
  "alerts.postStormSummary": "Sammanfattning efter regn",
  "alerts.postStormSynopsisHelper": "Du får en sammanfattande avisering varje gång regnet slutar.",
  "alerts.postStormSynopsisSoleCondition": "En sammanfattning efter regn kan inte kombineras med andra villkor.",
  "alerts.precipitationGreaterThan": "Timnederbörd större än",
  "alerts.precipitationGreaterThanThreshold": "Timnederbörd över tröskelvärdet {value}{unit}",
  "alerts.pressureGreaterThan": "Tryck större än",
  "alerts.pressureGreaterThanThreshold": "Tryck över tröskelvärdet {value}{unit}",
  "alerts.pressureLessThan": "Tryck mindre än",
  "alerts.pressureLessThanThreshold": "Tryck under tröskelvärdet {value}{unit}",
  "alerts.rainRateGreaterThan": "Regnintensitet större än",
  "alerts.rainRateGreaterThanThreshold": "Regnintensitet över tröskelvärdet {value}{unit}",
  "alerts.sensorNotReporting": "Den här sensorn skickar inga data just nu. Varningen återupptas när den skickar igen.",
  "alerts.soilMoistureGreaterThan": "Markfuktighet över",
  "alerts.soilMoistureGreaterThanThreshold": "Markfuktighet över tröskelvärdet {value}{unit}",
  "alerts.soilMoistureLessThan": "Markfuktighet under",
  "alerts.soilMoistureLessThanThreshold": "Markfuktighet under tröskelvärdet {value}{unit}",
  "alerts.solarRadiationGreaterThan": "Solinstrålning större än",
  "alerts.solarRadiationGreaterThanThreshold": "Solstrålning över tröskelvärdet {value}{unit}",
  "alerts.solarRadiationLessThan": "Solinstrålning mindre än",
  "alerts.solarRadiationLessThanThreshold": "Solstrålning under tröskelvärdet {value}{unit}",
  "alerts.stationNoLongerReports": "Den här stationen skickar inte längre data, så den här varningen kan inte utlösas.",
  "alerts.stormChartUnavailable": "Regnhistorik för det här regnet är inte tillgänglig.",
  "alerts.stormDetail": "Sammanfattning av regn",
  "alerts.stormDuration": "Varaktighet",
  "alerts.stormEnd": "Slut",
  "alerts.stormPeakRate": "Maximal regnintensitet",
  "alerts.stormStart": "Start",
  "alerts.stormTotal": "Total nederbörd",
  "alerts.temperatureGreaterThan": "Temperatur över",
  "alerts.temperatureGreaterThanThreshold": "Temperatur över tröskelvärdet {value}{unit}",
  "alerts.temperatureLessThan": "Temperatur under",
  "alerts.temperatureLessThanThreshold": "Temperatur under tröskelvärdet {value}{unit}",
  "alerts.thresholdOutOfRange": "Måste vara mellan {min} och {max}",
  "alerts.thswGreaterThan": "THSW större än",
  "alerts.thswGreaterThanThreshold": "THSW över tröskelvärdet {value}{unit}",
  "alerts.thswLessThan": "THSW mindre än",
  "alerts.thswLessThanThreshold": "THSW under tröskelvärdet {value}{unit}",
  "alerts.thwGreaterThan": "THW större än",
  "alerts.thwGreaterThanThreshold": "THW över tröskelvärdet {value}{unit}",
  "alerts.thwLessThan": "THW mindre än",
  "alerts.thwLessThanThreshold": "THW under tröskelvärdet {value}{unit}",
  "alerts.triggerHistory": "Larmhistorik",
  "alerts.uvGreaterThan": "UV högre än",
  "alerts.uvGreaterThanThreshold": "UV över tröskelvärdet {value}{unit}",
  "alerts.uvLessThan": "UV lägre än",
  "alerts.uvLessThanThreshold": "UV under tröskelvärdet {value}{unit}",
  "alerts.visibilityGreaterThanThreshold": "Synlighet över tröskelvärdet {value}{unit}",
  "alerts.visibilityLessThanThreshold": "Synlighet under tröskelvärdet {value}{unit}",
  "alerts.visiblityGreaterThan": "Sikt större än",
  "alerts.visiblityLessThan": "Sikt mindre än",
  "alerts.whichMeasure": "För vilket mätvärde skulle du vilja bli varnad?",
  "alerts.whichModule": "Vilken modul skulle du vilja bli varnad för?",
  "alerts.whichSensor": "Vilken sensor vill du bli varnad för?",
  "alerts.windChillGreaterThan": "Vindens kyleffekt större än",
  "alerts.windChillGreaterThanThreshold": "Vindens kyleffekt över tröskelvärdet {value}{unit}",
  "alerts.windChillLessThan": "Vindens kyleffekt mindre än",
  "alerts.windChillLessThanThreshold": "Vindens kyleffekt under tröskelvärdet {value}{unit}",
  "alerts.windSpeedGreaterThan": "Vinden större än",
  "alerts.windSpeedGreaterThanThreshold": "Vind över tröskelvärdet {value}{unit}",
  "alerts.windSpeedLessThan": "Vind mindre än",
  "alerts.windSpeedLessThanThreshold": "Vind under tröskelvärdet {value}{unit}",
  "appUpdate.updateAvailable": "Uppdatering tillgänglig",
  "appUpdate.updateAvailableOpenAppStore": "Tryck för att öppna App Store",
  "appUpdate.updateAvailableOpenGooglePlay": "Tryck för att öppna Google Play",
  "appUpdate.updateAvailableVersion": "Uppdatering tillgänglig: v{version}",
  "appUpdate.upgradeRequiredAndroid": "En uppgradering av din app krävs, gå till Google Play för att uppgradera.",
  "appUpdate.upgradeRequiredIos": "En uppgradering av din app krävs, gå till App Store för att uppgradera.",
  "astral.aboveHorizonAllDay": "Över horisonten hela dagen",
  "astral.aboveTheHorizon": "över horisonten",
  "astral.apparentSize": "Skenbar diameter",
  "astral.apparentSizeAcross": "{size} i diameter",
  "astral.astronomicalDawn": "Astronomisk gryning",
  "astral.astronomicalDusk": "Astronomisk skymning",
  "astral.belowHorizonAllDay": "Under horisonten hela dagen",
  "astral.belowHorizonSince": "Under horisonten sedan kl. {time}",
  "astral.belowHorizonSinceOn": "Under horisonten sedan {day} kl. {time}",
  "astral.brightAllNight": "Ljust hela natten — aldrig helt mörkt",
  "astral.brightestMoment": "Ljusaste stunden",
  "astral.civilDawn": "Borgerlig gryning",
  "astral.civilDusk": "Borgerlig skymning",
  "astral.darkSkyBetween": "Mörk himmel {from} → {to}",
  "astral.darkSkyWindow": "Mörk himmel {from} → {to} · {duration} utan måne",
  "astral.dayLength": "Daglängd",
  "astral.daylightThroughTheYear": "Daglängd under året",
  "astral.dayOfCycle": "dag {day} av {total}",
  "astral.doesNotOccurToday": "Inträffar inte i dag",
  "astral.domeHint": "Dra för att stega genom natten",
  "astral.domeReadout": "{time} · {altitude} · {direction}",
  "astral.earliestSunrise": "Tidigaste soluppgången",
  "astral.earliestSunset": "Tidigaste solnedgången",
  "astral.equinox": "Dagjämning",
  "astral.equinoxIn": "Dagjämning om {days, plural, one {# dag} other {# dagar}}",
  "astral.evening": "Kväll",
  "astral.exactPhaseAt": "Exakt kl. {time}",
  "astral.firstQuarter": "Första kvarteret",
  "astral.firstSunriseIn": "Första soluppgången om {days, plural, one {# dag} other {# dagar}}",
  "astral.firstSunsetIn": "Första solnedgången om {days, plural, one {# dag} other {# dagar}}",
  "astral.fullMoon": "Fullmåne",
  "astral.goldenHourBegins": "Gyllene timmen börjar",
  "astral.goldenHourEnds": "Gyllene timmen slutar",
  "astral.highestPoint": "Högsta punkt",
  "astral.inDays": "om {days, plural, one {# dag} other {# dagar}}",
  "astral.lastQuarter": "Sista kvarteret",
  "astral.latestSunrise": "Senaste soluppgången",
  "astral.latestSunset": "Senaste solnedgången",
  "astral.litShort": "Belyst",
  "astral.longestDay": "Längsta dagen",
  "astral.lowestPoint": "Lägsta punkt",
  "astral.maxAltitudeShort": "Max",
  "astral.midday": "Middag",
  "astral.midnightSun": "Midnattssol",
  "astral.midnightSunPeriod": "Midnattssol",
  "astral.milestoneFootnotePolar": "Här går solen varken upp eller ner {days, plural, one {# dag} other {# dagar}} om året, så i stället för de vanliga ytterligheterna för soluppgång och solnedgång visar listan när det sker.",
  "astral.milestoneFootnoteTemperate": "Den tidigaste solnedgången och den senaste soluppgången infaller inte på årets kortaste dag — det är tidsekvationen, inte solståndet, som avgör de två datumen.",
  "astral.moon": "Måne",
  "astral.moonAltitude": "Höjd",
  "astral.moonDirection": "Azimut",
  "astral.moonDistance": "Avstånd",
  "astral.moonlessFor": "{duration} utan måne",
  "astral.moonPhases": "Månfaser",
  "astral.moonrise": "Månuppgång",
  "astral.moonset": "Månnedgång",
  "astral.moonUpAllNight": "Månen är uppe hela natten",
  "astral.moonWashesOutNight": "Månen är uppe från {rise} till {set} och lyser upp hela natten",
  "astral.morning": "Morgon",
  "astral.nauticalDawn": "Nautisk gryning",
  "astral.nauticalDusk": "Nautisk skymning",
  "astral.newMoon": "Nymåne",
  "astral.nextDay": "+1 dag",
  "astral.nextProperlyDarkNight": "Nästa riktigt mörka natt",
  "astral.nextRise": "nästa uppgång kl. {time}",
  "astral.nextRiseOn": "nästa uppgång {day} kl. {time}",
  "astral.nextSevenNights": "De närmaste sju nätterna",
  "astral.nightDate": "Datum",
  "astral.noAstronomicalDarknessTonight": "Inget astronomiskt mörker i natt",
  "astral.noDarkNightAhead": "Ingen de närmaste två veckorna",
  "astral.noStationLocation": "Okänd plats",
  "astral.noStationLocationDescription": "Den här stationen har ingen registrerad position, så solen och månen kan inte beräknas för den.",
  "astral.noSunriseToday": "Ingen soluppgång i dag",
  "astral.nowAtBearing": "nu {altitude} · azimut {direction}",
  "astral.observing": "Observation",
  "astral.ofDaylightLeft": "dagsljus kvar",
  "astral.overTheNextThreeWeeks": "under de närmaste 3 veckorna",
  "astral.percentLit": "{percent} belyst",
  "astral.polarNight": "Polarnatt",
  "astral.polarNightPeriod": "Polarnatt",
  "astral.rightNow": "Just nu",
  "astral.riseShort": "Upp",
  "astral.setShort": "Ned",
  "astral.shortestDay": "Kortaste dagen",
  "astral.solarNoon": "Sann middag",
  "astral.solstice": "Solstånd",
  "astral.sunBelowHorizon": "Solen {degrees}° under horisonten",
  "astral.sunEvents": "Solhändelser",
  "astral.sunNeverDarkEnough": "Solen går aldrig 18° under horisonten",
  "astral.sunNeverSets": "Solen går inte ned",
  "astral.sunrise": "Soluppgång",
  "astral.sunriseAndSunset": "Soluppgång och solnedgång",
  "astral.sunriseAt": "Soluppgång kl. {time}",
  "astral.sunset": "Solnedgång",
  "astral.sunsetAt": "Solnedgång kl. {time}",
  "astral.thisYearAtNorth": "I år på {degrees}° N",
  "astral.thisYearAtSouth": "I år på {degrees}° S",
  "astral.tonight": "I natt",
  "astral.twilightAllNight": "Skymning hela natten — aldrig helt mörkt",
  "astral.upFor": "{duration} över horisonten",
  "astral.usableLight": "Användbart ljus",
  "astral.vsAverage": "{percent} mot snittet",
  "astral.vsYesterday": "mot i går",
  "astral.waningCrescent": "Avtagande månskära",
  "astral.waningGibbous": "Avtagande måne",
  "astral.waxingCrescent": "Tilltagande månskära",
  "astral.waxingGibbous": "Tilltagande måne",
  "astral.whereToLook": "Var du ska titta",
  "astral.withoutTheMoon": "{duration} utan måne",
  "auth.alreadyHaveAccount": "Har du redan ett konto?",
  "auth.authContainerTagline": "Din personliga väderpanel. Anslut dina stationer och få realtidsdata inom räckhåll.",
  "auth.backToLogin": "Tillbaka till inloggning",
  "auth.checkYourEmail": "Kontrollera din e-post",
  "auth.continueWithApple": "Fortsätt med Apple",
  "auth.continueWithFacebook": "Fortsätt med Facebook",
  "auth.continueWithGoogle": "Fortsätt med Google",
  "auth.email": "E-postadress",
  "auth.emailRequiredLoginFacebook": "E-postbehörighet krävs för att ansluta med Facebook",
  "auth.emailVerification": "E-postverifiering",
  "auth.emailVerificationFailure": "Ett problem har uppstått med din e-postverifikation",
  "auth.emailVerificationSuccess": "Din e-postadress har blivit verifierad",
  "auth.firstName": "Förnamn",
  "auth.forgotPassword": "Glömt lösenord?",
  "auth.forgotPasswordSubtitle": "Ange din e-postadress så skickar vi en länk för att återställa ditt lösenord.",
  "auth.lastName": "Efternamn",
  "auth.login": "Logga in",
  "auth.loginSubtitle": "Välkommen tillbaka! Vänligen ange dina uppgifter.",
  "auth.loginToSmartMixinDescription": "Logga in på SmartMixin för att komma åt dina väderstationer, se analyser och hantera din personliga väderpanel.",
  "auth.logout": "Logga ut",
  "auth.logoutConfirmation": "Vill du logga ut?",
  "auth.noAccountYet": "Har du inget konto ännu?",
  "auth.or": "eller",
  "auth.password": "Lösenord",
  "auth.passwordReset": "Återställning av lösenord",
  "auth.passwordResetSuccess": "Ditt lösenord har uppdaterats.",
  "auth.register": "Skapa konto",
  "auth.registerDescription": "Skapa ett gratis SmartMixin-konto för att ansluta dina väderstationer, följa väderdata och få tillgång till kraftfulla analysverktyg.",
  "auth.registerSubtitle": "Skapa ditt konto för att komma igång.",
  "auth.restorePassword": "Återställ lösenord",
  "auth.restorePasswordSuccess": "Vi har skickat en länk till återställning av lösenord till {emailAddress} med ytterligare instruktioner.",
  "auth.sendReset": "Skicka återställningsinstruktioner",
  "auth.signInWithApple": "Logga in med Apple",
  "auth.socialAccount": "eller använd ditt konto",
  "auth.staffVerificationCode": "Verifieringskod",
  "auth.staffVerificationExpiresIn": "Verifierad. Upphör om {duration}.",
  "auth.staffVerificationInvalidCode": "Fel kod. Försök igen.",
  "auth.staffVerificationLoginAsStopped": "Login As har stoppats: ange en verifieringskod på Debug-skärmen för att fortsätta.",
  "auth.staffVerificationNotEnrolled": "Ingen autentiseringsapp är konfigurerad för ditt konto. Lägg till en i säkerhetsinställningarna i back office.",
  "auth.staffVerificationPasskey": "Verifiera med nyckel",
  "auth.staffVerificationPasskeyExpired": "Nyckelbegäran har gått ut. Försök igen.",
  "auth.staffVerificationPasskeyFailed": "Verifieringen med nyckel misslyckades. Försök igen eller ange en kod.",
  "auth.staffVerificationPasskeyNotEnrolled": "Det finns ingen nyckel för ditt konto på den här telefonen. Lägg till en från den här telefonen i säkerhetsinställningarna i back office, eller ange en kod.",
  "auth.staffVerificationPasskeySetupLink": "Lägg till en nyckel",
  "auth.staffVerificationPasskeyUnavailable": "Nycklar kan inte användas här. Ange en kod i stället.",
  "auth.staffVerificationPrompt": "Ange den 6-siffriga koden från din autentiseringsapp, eller en återställningskod, för att använda Login As och användarsökning.",
  "auth.staffVerificationPromptPasskey": "Använd din nyckel, eller ange den 6-siffriga koden från din autentiseringsapp eller en återställningskod, för att använda Login As och användarsökning.",
  "auth.staffVerificationSetupLink": "Lägg till en autentiseringsapp",
  "auth.staffVerificationSubmit": "Verifiera",
  "auth.staffVerificationTitle": "Personalverifiering",
  "calendar.afternoon": "Eftermiddag",
  "calendar.april": "April",
  "calendar.august": "Augusti",
  "calendar.changePeriod": "Period: {period}. Ändra period",
  "calendar.currentDay": "I dag",
  "calendar.dateFormat": "Datumformat",
  "calendar.day": "Dag",
  "calendar.december": "December",
  "calendar.durationHours": "{hours} h",
  "calendar.durationHoursMinutes": "{hours} h {minutes} min",
  "calendar.durationMinutes": "{minutes} min",
  "calendar.durationMinutesSeconds": "{minutes} min {seconds} s",
  "calendar.durationSeconds": "{seconds} s",
  "calendar.earlierYears": "Tidigare år",
  "calendar.endTime": "Sluttid",
  "calendar.evening": "Kväll",
  "calendar.february": "Februari",
  "calendar.goToNextDay": "Nästa dag",
  "calendar.goToNextMonth": "Nästa månad",
  "calendar.goToNextWeek": "Nästa vecka",
  "calendar.goToNextYear": "Nästa år",
  "calendar.goToPreviousDay": "Föregående dag",
  "calendar.goToPreviousMonth": "Föregående månad",
  "calendar.goToPreviousWeek": "Föregående vecka",
  "calendar.goToPreviousYear": "Föregående år",
  "calendar.hour": "Timme",
  "calendar.hoursCount": "{count, plural, one {# timme} other {# timmar}}",
  "calendar.hoursShort": "h",
  "calendar.hoursShortCount": "{count, plural, one {# h} other {# h}}",
  "calendar.january": "Januari",
  "calendar.july": "Juli",
  "calendar.june": "Juni",
  "calendar.last12Hours": "Senaste 12 timmarna",
  "calendar.last24Hours": "Senaste 24 timmarna",
  "calendar.last30Days": "Senaste 30 dagarna",
  "calendar.last3Hours": "Senaste 3 timmarna",
  "calendar.last6Hours": "Senaste 6 timmarna",
  "calendar.last7Days": "Senaste 7 dagarna",
  "calendar.lastHour": "Senaste timmen",
  "calendar.laterYears": "Senare år",
  "calendar.march": "Mars",
  "calendar.max": "Max",
  "calendar.may": "Maj",
  "calendar.month": "Månad",
  "calendar.monthTotal": "Månadssumma",
  "calendar.morning": "Morgon",
  "calendar.nextHours": "Följande timmar",
  "calendar.night": "Natt",
  "calendar.november": "November",
  "calendar.october": "Oktober",
  "calendar.oneDay": "1 dag",
  "calendar.oneHour": "1 timme",
  "calendar.oneMonth": "1 månad",
  "calendar.oneWeek": "1 vecka",
  "calendar.periodRangeSpoken": "{start} till {end}",
  "calendar.previous24Hours": "Föregående 24 timmar",
  "calendar.previous30Days": "Föregående 30 dagar",
  "calendar.previous7Days": "Föregående 7 dagar",
  "calendar.previousDay": "Föregående dag",
  "calendar.previousHours": "Tidigare timmar",
  "calendar.previousMonth": "Föregående månad",
  "calendar.previousWeek": "Föregående vecka",
  "calendar.previousYear": "Föregående år",
  "calendar.sameDayLastYear": "Samma dag föregående år",
  "calendar.sameMonthLastYear": "Samma månad föregående år",
  "calendar.selectADate": "Välj ett datum",
  "calendar.selectAggregation": "Välj visat värde",
  "calendar.selectAMonth": "Välj en månad",
  "calendar.selectAYear": "Välj ett år",
  "calendar.selectGranularity": "Välj en upplösning",
  "calendar.selectPeriod": "Välj en period",
  "calendar.september": "September",
  "calendar.sixHours": "6 timmar",
  "calendar.startTime": "Starttid",
  "calendar.thirtyMinutes": "30 min",
  "calendar.threeHours": "3 timmar",
  "calendar.timezone": "Tidszon",
  "calendar.today": "Idag",
  "calendar.untilChanged": "Tills vidare",
  "calendar.untilTime": "Fram till {time}",
  "calendar.untilTodayAt": "Fram till i dag kl. {time}",
  "calendar.untilTomorrowAt": "Fram till i morgon kl. {time}",
  "calendar.use24HourFormat": "Använd 24-timmarsformat",
  "calendar.week": "Vecka",
  "calendar.year": "År",
  "calendar.yearToDate": "Det här året",
  "calendar.yesterday": "I går",
  "charts.averageOverThePeriod": "Genomsnitt under perioden",
  "charts.calendarView": "Kalendervy",
  "charts.charts": "Diagram",
  "charts.chartView": "Diagramvy",
  "charts.comparison": "Jämförelse",
  "charts.customizeComparisonMetrics": "Anpassa mätvärden",
  "charts.customizeComparisonMetricsDescription": "Dra objekt för att ordna om dina jämförelsemått. Tryck på ögonikonen för att visa eller dölja mätvärden.",
  "charts.loading": "Läser in diagram",
  "charts.maxOverThePeriod": "Maximum under perioden",
  "charts.measureToDisplay": "Mätvärde att visa",
  "charts.minMaxRange": "Min. / Max.",
  "charts.noDataForThisPeriod": "Ingen data för denna period",
  "charts.observations": "Observationer",
  "charts.observedTemperature": "Uppmätt temperatur",
  "charts.seriesTableDate": "Datum",
  "charts.showComparison": "Visa jämförelse",
  "charts.stationComparison": "Stationsjämförelse",
  "charts.stationComparisonDescription": "Låter dig jämföra historisk väderdata med den för en annan station.",
  "charts.sumOverThePeriod": "Ackumulerat under perioden",
  "charts.tableLabel": "Tabell: {chart}",
  "charts.toggleSeries": "Visa eller dölj {series}",
  "charts.viewAsChart": "Diagram",
  "charts.viewAsList": "Lista",
  "charts.viewAsPeriods": "Perioder",
  "charts.viewAsTable": "Tabell",
  "charts.viewLabel": "Visning: {chart}",
  "common.add": "Lägg till",
  "common.altitude": "Altitud",
  "common.analysis": "Analys",
  "common.average": "Genomsnitt",
  "common.back": "Tillbaka",
  "common.backToHome": "Tillbaka till startsidan",
  "common.cancel": "Avbryt",
  "common.cannotBeEmpty": "Det här fältet får inte vara tomt.",
  "common.close": "Stäng",
  "common.dailyForecast": "Daglig prognos",
  "common.default": "Standard",
  "common.delete": "Radera",
  "common.details": "Detaljer",
  "common.edit": "Redigera",
  "common.exitFullscreen": "Avsluta helskärm",
  "common.forecast": "Prognos",
  "common.frequency": "Frekvens",
  "common.full": "Full",
  "common.fullscreen": "Helskärm",
  "common.help": "Hjälp",
  "common.hidden": "Dolda",
  "common.high": "Hög",
  "common.iDontKnowYet": "Jag vet inte ännu",
  "common.indoor": "Inomhus",
  "common.labelValue": "{label}: {value}",
  "common.lastUpdate": "Senaste uppdatering",
  "common.low": "Låg",
  "common.maximum": "Maximum",
  "common.medium": "Medel",
  "common.minimum": "Minimum",
  "common.more": "Mer",
  "common.moreInformation": "Mer information",
  "common.next": "Nästa",
  "common.no": "Nej",
  "common.noAccountNeeded": "Inget konto krävs",
  "common.noItemsAvailable": "Inga objekt tillgängliga",
  "common.notNow": "Inte nu",
  "common.now": "Nu",
  "common.openSettings": "Öppna inställningar",
  "common.outdoor": "Utomhus",
  "common.pageNotFound": "Sidan hittades inte",
  "common.pageNotFoundDescription": "Sidan du letar efter finns inte eller har flyttats.",
  "common.rain": "Nederbörd",
  "common.reorderCancel": "Flytten avbröts: {item}. Tillbaka på plats {position} av {count}.",
  "common.reorderEnd": "Släpptes: {item}. Plats {position} av {count}.",
  "common.reorderInstructions": "Flytta objektet genom att trycka på blanksteg eller Enter, välja plats med uppåt- och nedåtpilarna och sedan trycka på blanksteg eller Enter igen för att släppa det, eller på Escape för att avbryta.",
  "common.reorderOver": "{item}: nu på plats {position} av {count}.",
  "common.reorderStart": "Plockades upp: {item}. Plats {position} av {count}.",
  "common.share": "Dela",
  "common.shareImageFailed": "Det gick inte att dela bilden",
  "common.shareYourWeather": "Dela ditt väder",
  "common.skip": "Hoppa över",
  "common.start": "Start",
  "common.unknown": "Okänd",
  "common.validate": "Bekräfta",
  "common.validEmail": "En giltig e-postadress krävs.",
  "common.very_low": "Mycket låg",
  "common.weatherObservations": "Väderobservationer",
  "common.welcome": "Välkommen till SmartMixin!",
  "common.wind": "Vind",
  "common.yes": "Ja",
  "common.zoomImage": "Förstora bilden",
  "compass.E": "O",
  "compass.E_long": "Öster",
  "compass.ENE": "ONO",
  "compass.ENE_long": "Ostnordost",
  "compass.ESE": "OSO",
  "compass.ESE_long": "Ostsydost",
  "compass.N": "N",
  "compass.N_long": "Norr",
  "compass.NE": "NO",
  "compass.NE_long": "Nordost",
  "compass.NNE": "NNO",
  "compass.NNE_long": "Nordnordost",
  "compass.NNW": "NNV",
  "compass.NNW_long": "Nordnordväst",
  "compass.NW": "NV",
  "compass.NW_long": "Nordväst",
  "compass.S": "S",
  "compass.S_long": "Söder",
  "compass.SE": "SO",
  "compass.SE_long": "Sydost",
  "compass.SSE": "SSO",
  "compass.SSE_long": "Sydsydost",
  "compass.SSW": "SSV",
  "compass.SSW_long": "Sydsydväst",
  "compass.SW": "SV",
  "compass.SW_long": "Sydväst",
  "compass.W": "V",
  "compass.W_long": "Väster",
  "compass.WNW": "VNV",
  "compass.WNW_long": "Västnordväst",
  "compass.WSW": "VSV",
  "compass.WSW_long": "Västsydväst",
  "dashboard.currentObservations": "Nuvarande observationer",
  "dashboard.currentRainEvent": "Aktuell regnhändelse",
  "dashboard.currentWeatherConditions": "Aktuellt väder",
  "dashboard.customizeDashboard": "Anpassa",
  "dashboard.customizeDashboardDescription": "Dra objekt för att ändra ordningen på din instrumentpanel. Tryck på ögonsymbolen för att visa eller dölja sektioner.",
  "dashboard.dashboard": "Start",
  "dashboard.dayRangeExpected": "{value} väntas kl. {time}",
  "dashboard.dayRangeReached": "{value} kl. {time}",
  "dashboard.dayRangeSteady": "Stabilt {value} hela dagen",
  "dashboard.hiddenSensors": "Dolda sensorer",
  "dashboard.hideSensor": "Dölj {sensor}",
  "dashboard.lastRainEvent": "Sista regnhändelsen",
  "dashboard.lastVisibleSensor": "Minst en sensor måste förbli synlig.",
  "dashboard.manageSensors": "Hantera sensorer",
  "dashboard.manageSensorsDescription": "Dra objekt för att ändra ordningen på sensorer. Tryck på ögonsymbolen för att visa eller dölja sensorer. Tryck på ett namn för att byta namn.",
  "dashboard.manageSensorsDescriptionWeb": "Klicka på pennan för att byta namn på en sensor, dra i handtaget för att ändra ordningen och klicka på ögat för att dölja eller visa den.",
  "dashboard.moveSensor": "Flytta {sensor}",
  "dashboard.pressureSummary": "Lufttryckssammanfattning",
  "dashboard.rainEvents": "Regnhändelser",
  "dashboard.rainSummary": "Nederbördssammanfattning",
  "dashboard.renameSensor": "Byt namn på {sensor}",
  "dashboard.shareOutdoorMeasures": "Dela dina utomhusdata",
  "dashboard.shareOutdoorMeasuresDescription": "Delta i SmartMixin-communityn genom att göra dina utomhusdata synliga för andra. Inomhusdata kommer aldrig att delas.",
  "dashboard.showSensor": "Visa {sensor}",
  "dashboard.temperatureSummary": "Temperatursammanfattning",
  "dashboard.useDefaultSensorName": "Använd standardnamnet",
  "dashboard.windSummary": "Vindsammanfattning",
  "devices.batteryLevel": "Batterinivå",
  "devices.firmwareVersion": "Firmware-version",
  "devices.moduleCount": "{count, plural, one {# modul} other {# moduler}}",
  "devices.moduleType": "Modultyp",
  "devices.noNetatmoWeatherStationYet": "Du har ingen Netatmo-väderstation ännu.",
  "devices.noOutdoorModule": "Det finns ingen fungerande utomhusmodul för denna station.",
  "devices.notReachable": "Ingen kontakt",
  "devices.serialNumber": "Serienummer",
  "devices.signalAverage": "Måttlig",
  "devices.signalBad": "Svag",
  "devices.signalGood": "Bra",
  "devices.signalStrength": "Signalstyrka",
  "devices.signalUnknown": "Okänd",
  "devices.visitNetatmoWebsite": "Besök Netatmo Websida",
  "devices.wifiStrength": "Wi-Fi-signalstyrka",
  "forecastMaps.addColor": "Lägg till färg",
  "forecastMaps.addLayer": "Lägg till lager",
  "forecastMaps.autoDescription": "Det bästa för den här vyn",
  "forecastMaps.autoDescriptionFree": "Gratiskonton använder {model}",
  "forecastMaps.autoPreview": "Auto",
  "forecastMaps.autoSwitched": "Visar nu {model}: {previous} täcker {coverage, number, percent} av den här vyn",
  "forecastMaps.backToMaps": "Tillbaka till kartorna",
  "forecastMaps.build": "Generera",
  "forecastMaps.buildCompleted": "Generering klar",
  "forecastMaps.builderMetaDescription": "Sätt ihop egna prognoskartor av vädermodellernas lager.",
  "forecastMaps.builderTitle": "Kartbyggare",
  "forecastMaps.buildFailed": "Genereringen misslyckades. Försök igen.",
  "forecastMaps.buildNotPossible": "Den här kartan kan inte genereras ännu — inga prognosdata är tillgängliga.",
  "forecastMaps.buildProgress": "Renderar… {completed}/{total} steg",
  "forecastMaps.buildStarting": "Startar generering…",
  "forecastMaps.byModel": "Efter modell",
  "forecastMaps.byZone": "Efter zon",
  "forecastMaps.colormap": "Färgskala",
  "forecastMaps.colormapCustom": "Anpassade färger",
  "forecastMaps.colormapGroupDomain": "Väderförval",
  "forecastMaps.colormapGroupMatplotlib": "Vetenskapliga förval",
  "forecastMaps.colorStop": "Färg {position}",
  "forecastMaps.configUnavailable": "Den här prognoskartan är inte tillgänglig. {name} visas i stället.",
  "forecastMaps.contourLevels": "Konturnivåer",
  "forecastMaps.countryCanada": "Kanada",
  "forecastMaps.countryFrance": "Frankrike",
  "forecastMaps.countryGermany": "Tyskland",
  "forecastMaps.countryItaly": "Italien",
  "forecastMaps.countryScandinavia": "Skandinavien",
  "forecastMaps.countrySpain": "Spanien",
  "forecastMaps.countrySwitzerland": "Schweiz",
  "forecastMaps.countryUnitedStates": "USA",
  "forecastMaps.coverageUnknown": "Område okänt",
  "forecastMaps.coversView": "Täcker {coverage, number, percent} av den här vyn",
  "forecastMaps.customColormapMinColors": "En anpassad färgskala kräver minst två färger",
  "forecastMaps.customExtent": "Anpassat område",
  "forecastMaps.displayName": "Visningsnamn",
  "forecastMaps.downscaling": "Gallringsfaktor för vindpilar",
  "forecastMaps.dpi": "DPI",
  "forecastMaps.drawArea": "Rita område",
  "forecastMaps.east": "Öst",
  "forecastMaps.extentDrawHint": "Dra på kartan för att rita området",
  "forecastMaps.extentInvalid": "Väst måste vara mindre än öst och syd mindre än nord",
  "forecastMaps.frameTime": "Prognostid",
  "forecastMaps.height": "Höjd (tum)",
  "forecastMaps.hourOffset": "+{hour} h",
  "forecastMaps.inThisArea": "I det här området",
  "forecastMaps.invalidHexColor": "Ogiltig färg — använd #RRGGBB",
  "forecastMaps.layerHasErrors": "Det här lagret innehåller fel",
  "forecastMaps.layers": "Lager",
  "forecastMaps.layerTypeBarbs": "Vindpilar",
  "forecastMaps.layerTypeContour": "Konturlinjer",
  "forecastMaps.layerTypeFilledContour": "Fyllda konturer",
  "forecastMaps.layerTypeMagnitude": "Magnitud",
  "forecastMaps.layerTypeRaster": "Raster",
  "forecastMaps.layerTypeVectorField": "Vektorfält",
  "forecastMaps.leave": "Lämna",
  "forecastMaps.levelsCount": "Antal",
  "forecastMaps.levelsInvalid": "Ogiltiga konturnivåer",
  "forecastMaps.levelsModeArange": "Fast steg",
  "forecastMaps.levelsModeExplicit": "Explicita värden",
  "forecastMaps.levelsModeLinspace": "Jämnt fördelade (antal)",
  "forecastMaps.levelsStep": "Steg",
  "forecastMaps.levelsValues": "Värden",
  "forecastMaps.levelsValuesHint": "Kommaseparerade, stigande",
  "forecastMaps.loadingMaps": "Läser in kartor…",
  "forecastMaps.localTimeHint": "Visas i din lokala tid",
  "forecastMaps.lockedConfig": "{model} är en Premium-modell. {fallback} visas i stället.",
  "forecastMaps.lockedVariable": "{variable}, Premium",
  "forecastMaps.mapDescription": "Beskrivning",
  "forecastMaps.mapName": "Kartnamn",
  "forecastMaps.mapNameRequired": "Ange ett namn",
  "forecastMaps.mapSettings": "Kartinställningar",
  "forecastMaps.maxLayersReached": "Den här kartan har nått maxantalet {max} lager.",
  "forecastMaps.maxValue": "Maxvärde",
  "forecastMaps.memoryBudgetExceeded": "Upplösningen överskrider renderingsbudgeten — minska DPI eller höjd",
  "forecastMaps.memoryBudgetUsage": "Renderingsbudget: {percent}%",
  "forecastMaps.metaDescription": "Animerade prognoskartor genererade från vädermodellernas körningar.",
  "forecastMaps.metric": "Mätvärde",
  "forecastMaps.metricRequired": "Välj ett mätvärde",
  "forecastMaps.metricUnavailable": "Inte tillgängligt för den här modellen",
  "forecastMaps.minBelowMax": "Min måste vara mindre än max",
  "forecastMaps.minMaxRequired": "Min- och maxvärden krävs för den här lagertypen",
  "forecastMaps.minValue": "Minvärde",
  "forecastMaps.modelChipAuto": "Auto · {model}",
  "forecastMaps.modelCoversView": "{model} täcker {coverage, number, percent} av den här vyn",
  "forecastMaps.modelNoRun": "Ingen slutförd körning ännu",
  "forecastMaps.modelOption": "{model}, {grid}",
  "forecastMaps.moveLayerDown": "Flytta ned",
  "forecastMaps.moveLayerUp": "Flytta upp",
  "forecastMaps.nanClipToMin": "Begränsa till min",
  "forecastMaps.nanMask": "Maskera",
  "forecastMaps.nanPolicy": "Saknade data",
  "forecastMaps.nanSkip": "Hoppa över",
  "forecastMaps.noCompletedRun": "Den här kartan har inte genererats än. Titta tillbaka snart.",
  "forecastMaps.noLayers": "Inga lager ännu. Lägg till ett lager för att komma igång.",
  "forecastMaps.noMapsAvailable": "Inga prognoskartor är tillgängliga än.",
  "forecastMaps.north": "Nord",
  "forecastMaps.opacity": "Opacitet",
  "forecastMaps.openAsAnimation": "Öppna som animation",
  "forecastMaps.otherAreas": "Andra områden",
  "forecastMaps.outsideArea": "Täcker inte det här området",
  "forecastMaps.overlayLegend": "Teckenförklaring",
  "forecastMaps.pause": "Paus",
  "forecastMaps.play": "Spela upp",
  "forecastMaps.pointValueAnnouncement": "{value}, {time}",
  "forecastMaps.pointValueError": "Prognosen för denna punkt kunde inte läsas in.",
  "forecastMaps.pointValueLoading": "Läser in prognos…",
  "forecastMaps.pointValueUnavailable": "Inga data för denna tidpunkt.",
  "forecastMaps.premiumModelForView": "{model} täcker den här vyn",
  "forecastMaps.premiumRequired": "Prognoskartor kräver Premium",
  "forecastMaps.preview": "Förhandsvisning",
  "forecastMaps.previewEmptyHint": "Konfigurera minst ett giltigt lager för att rendera en förhandsvisning.",
  "forecastMaps.previewFailed": "Förhandsvisningen misslyckades",
  "forecastMaps.previewHour": "Prognostimme",
  "forecastMaps.previewRendering": "Renderar förhandsvisning…",
  "forecastMaps.projection": "Projektion",
  "forecastMaps.projectionLambertConformal": "Lambert konform",
  "forecastMaps.projectionMercator": "Mercator",
  "forecastMaps.projectionPlateCarree": "Plate carrée",
  "forecastMaps.projectionStereographic": "Stereografisk",
  "forecastMaps.regionEurope": "Europa",
  "forecastMaps.regionNorthAmerica": "Nordamerika",
  "forecastMaps.removeColor": "Ta bort färg",
  "forecastMaps.removeLayer": "Ta bort lager",
  "forecastMaps.retry": "Försök igen",
  "forecastMaps.run": "Körning: {run}",
  "forecastMaps.runNotDisplayable": "Den här körningen kan inte visas på den interaktiva kartan.",
  "forecastMaps.save": "Spara",
  "forecastMaps.selectExtentOnMap": "Välj område på kartan",
  "forecastMaps.showArea": "Visa område",
  "forecastMaps.showAreaOf": "Visa område, {model}",
  "forecastMaps.south": "Syd",
  "forecastMaps.switchToModel": "Byt till {model}",
  "forecastMaps.title": "Prognoskartor",
  "forecastMaps.uMetric": "U-komponent",
  "forecastMaps.unitConversion": "Enhetskonvertering",
  "forecastMaps.unitNone": "Ingen",
  "forecastMaps.unsavedChangesBody": "Du har osparade ändringar. Lämna och kasta dem?",
  "forecastMaps.unsavedChangesTitle": "Osparade ändringar",
  "forecastMaps.useCurrentView": "Använd aktuell vy",
  "forecastMaps.useModelDomain": "Av: modellens hela domän används",
  "forecastMaps.utcTime": "UTC: {time}",
  "forecastMaps.uvMetricsDiffer": "U- och V-mätvärden måste vara olika",
  "forecastMaps.valueBetween": "Måste vara mellan {min} och {max}",
  "forecastMaps.variable": "Variabel",
  "forecastMaps.variableMissing": "{variable}: saknas",
  "forecastMaps.variableOnlyFrom": "{variable} kommer bara från {model}",
  "forecastMaps.viewMap": "Visa karta",
  "forecastMaps.vMetric": "V-komponent",
  "forecastMaps.west": "Väst",
  "forecastMaps.windAnimation": "Vindanimation",
  "forecastModels.addForecastModel": "Lägg till en modell",
  "forecastModels.atYourStations": "Tillgängliga vid dina stationer",
  "forecastModels.comparisonLoadError": "Det gick inte att läsa in jämförelsen av vädermodeller",
  "forecastModels.coverageLoading": "Räknar ut vilka av dina stationer varje modell täcker…",
  "forecastModels.description_AROME": "Météo Frances konvektionsupplösande högupplösningsmodell över Västeuropa med 1,3 km upplösning. Bäst i klassen för korttidsprognoser i Frankrike; uppdateras var tredje timme.",
  "forecastModels.description_ARPEGE_EU": "Météo Frances europeiska nästade domän i ARPEGE-modellen med 10 km upplösning. Medellånga prognoser över Europa, uppdateras fyra gånger om dagen.",
  "forecastModels.description_ARPEGE_GLOBAL": "Météo Frances globala numeriska väderprognosmodell med 25 km upplösning, som körs upp till cirka 4 dagar. Uppdateras fyra gånger om dagen.",
  "forecastModels.description_DMI_DINI": "DMI:s HARMONIE DINI: en konvektionsupplösande modell över nordvästra Europa — Danmark, Benelux, Irland, Storbritannien och Skandinavien — med 2 km upplösning som körs upp till 60 timmar, uppdateras åtta gånger om dagen. Innehåller modifierade öppna data från DMI (CC BY 4.0).",
  "forecastModels.description_EC_GDPS": "Environment Canadas Global Deterministic Prediction System: en världsomspännande medellång modell med 15 km upplösning som körs upp till 10 dagar, uppdateras två gånger om dagen.",
  "forecastModels.description_EC_HRDPS": "Environment Canadas High Resolution Deterministic Prediction System: en konvektionsupplösande modell över Kanada och norra USA med 2,5 km upplösning som körs upp till 48 timmar, uppdateras fyra gånger om dagen.",
  "forecastModels.description_EC_RDPS": "Environment Canadas Regional Deterministic Prediction System: en medellång modell över Nordamerika med 10 km upplösning, uppdateras fyra gånger om dagen.",
  "forecastModels.description_ECMWF_HRES": "Det europeiska centret för medellånga väderprognosers flaggskeppsmodell med hög upplösning (IFS), allmänt betraktad som världens ledande globala prognossystem. Täcker hela planeten med 25 km upplösning upp till 15 dagar, uppdateras fyra gånger dagligen. Innehåller modifierade öppna data från ECMWF (CC BY 4.0).",
  "forecastModels.description_GFS": "NOAA:s medellånga globala flaggskeppsmodell. Täcker hela planeten med 25 km upplösning upp till 16 dagar, uppdateras fyra gånger om dagen.",
  "forecastModels.description_HRRR_CONUS": "NOAA:s High-Resolution Rapid Refresh: en konvektionsupplösande modell över kontinentala USA med 3 km upplösning, uppdateras varje timme. Bäst lämpad för mycket korttidsprognoser av åskväder och svårt väder.",
  "forecastModels.description_ICON": "DWD:s globala ICON-modell med 13 km upplösning som täcker hela planeten upp till 7,5 dagar, uppdateras fyra gånger om dagen. Datenbasis: Deutscher Wetterdienst.",
  "forecastModels.description_ICON_2I": "ItaliaMeteos ICON-2I, som drivs tillsammans med ARPAE: en konvektionsupplösande modell över Italien med 2,2 km upplösning som körs upp till 72 timmar, uppdateras två gånger om dagen. Innehåller öppna data från ItaliaMeteo (CC BY 4.0).",
  "forecastModels.description_ICON_CH1": "MeteoSwiss ICON-CH1-EPS-kontrollkörning: en konvektionsupplösande modell över Alperna med 1 km upplösning som körs upp till 33 timmar, uppdateras var tredje timme.",
  "forecastModels.description_ICON_CH2": "MeteoSwiss ICON-CH2-EPS-kontrollkörning: en konvektionsupplösande modell över Alperna — Schweiz och den omgivande alpregionen — med 2,1 km upplösning som körs upp till 120 timmar, uppdateras fyra gånger om dagen.",
  "forecastModels.description_ICON_DE": "DWD:s högupplösta konvektionsupplösande modell över Tyskland och kringliggande länder med 2,2 km upplösning. Korttidsprognoser uppdateras två gånger om dagen. Datenbasis: Deutscher Wetterdienst.",
  "forecastModels.description_ICON_EU": "DWD:s europeiska nästade domän i ICON-modellen med 7 km upplösning som täcker Europa och Nordatlanten. Medellånga prognoser uppdateras fyra gånger om dagen. Datenbasis: Deutscher Wetterdienst.",
  "forecastModels.description_MET_NORWAY": "Norska meteorologiska institutets öppna väderprognostjänst, som kombinerar högupplösta nordiska modeller med ECMWF-data för att ge världsomspännande prognoser upp till 10 dagar framåt.",
  "forecastModels.description_MF_AROME_ANTILLES": "Nästad AROME-domän över de franska Antillerna (Guadeloupe, Martinique) med 2,5 km upplösning. Korttidsprognoser uppdateras fyra gånger om dagen.",
  "forecastModels.description_MF_AROME_GUYANE": "Nästad AROME-domän över Franska Guyana med 2,5 km upplösning. Korttidsprognoser uppdateras fyra gånger om dagen.",
  "forecastModels.description_MF_AROME_NOUVELLE_CALEDONIE": "Nästad AROME-domän över Nya Kaledonien med 2,5 km upplösning. Korttidsprognoser uppdateras fyra gånger om dagen.",
  "forecastModels.description_MF_AROME_POLYNESIE": "Nästad AROME-domän över Franska Polynesien med 2,5 km upplösning. Korttidsprognoser uppdateras fyra gånger om dagen.",
  "forecastModels.description_MF_AROME_REUNION_MAYOTTE": "Nästad AROME-domän över Réunion och Mayotte med 2,5 km upplösning. Korttidsprognoser uppdateras fyra gånger om dagen.",
  "forecastModels.description_RRFS_CONUS": "NOAA:s Rapid Refresh Forecast System över kontinentala USA med 3 km upplösning. Timprognoser uppdaterade åtta gånger dagligen, upp till 84 timmar för de fyra huvudkörningarna och 18 timmar för de övriga.",
  "forecastModels.description_RRFS_NORTH_AMERICA": "NOAA:s Rapid Refresh Forecast System över hela Nordamerika med 13 km upplösning. Timprognoser upp till 84 timmar, uppdaterade fyra gånger dagligen.",
  "forecastModels.description_SMARTMIXIN_MULTIMODEL": "SmartMixins flaggskeppsprognos. För varje timme på din plats väljer vi den bästa tillgängliga modellen — vanligtvis en högupplöst regional modell där det finns en (AROME i Frankrike, ICON-D2 i Tyskland, HRRR i USA, ARPEGE Europe över hela kontinenten…) och vi faller tillbaka på en global modell på andra ställen — sedan fyller vi i eventuella luckor från grannkällor. Resultatet är en enda sömlös prognos som täcker var som helst i världen upp till 14 dagar, automatiskt uppdaterad varje gång någon av de underliggande modellerna uppdateras.",
  "forecastModels.description_WEATHERFLOW_FORECAST": "Weatherflows egenutvecklade globala prognos som kombinerar flera numeriska vädermodeller med observationer från dess Tempest-väderstationsnätverk. 10-dagars världsomspännande horisont.",
  "forecastModels.everywhereElse": "Överallt annars",
  "forecastModels.everywhereElseFoot": "Används vid varje station som dina föredragna modeller inte når.",
  "forecastModels.everywhereElsePick": "Välj en",
  "forecastModels.fallbackBlend": "SmartMixin-blandning",
  "forecastModels.fallbackBlendSub": "Kombinerar flera modeller, var och en där den är starkast.",
  "forecastModels.fallbackEcmwf": "ECMWF",
  "forecastModels.fallbackEcmwfSub": "ECMWF HRES överallt där den når.",
  "forecastModels.fallbackGfs": "GFS",
  "forecastModels.fallbackGfsSub": "NOAA:s globala modell. Det som alla konton använder i dag.",
  "forecastModels.fallbackResolution": "Högsta upplösning",
  "forecastModels.fallbackResolutionSub": "Det finaste rutnätet som finns vid varje station.",
  "forecastModels.forecastChipLabelWithRun": "{model}, körning {run}",
  "forecastModels.forecastChipRunHint": "Tryck länge för att visa eller dölja den senaste körningen",
  "forecastModels.forecastComparisonDescription": "Jämför enkelt data från olika tillgängliga vädermodeller",
  "forecastModels.forecastFollowingPreferences": "Följer dina inställningar",
  "forecastModels.forecastLoadError": "Det gick inte att läsa in prognosen",
  "forecastModels.forecastModel": "Prognosmodell",
  "forecastModels.forecastModelAbout": "Om {model}",
  "forecastModels.forecastModelComparison": "Jämförelse av vädermodeller",
  "forecastModels.forecastModelCoverage": "Täckning",
  "forecastModels.forecastModelDescription": "Beskrivning",
  "forecastModels.forecastModels": "Prognosmodeller",
  "forecastModels.forecastModelScopeGlobal": "Global",
  "forecastModels.forecastModelScopeGlobalDescription": "Denna modell täcker hela planeten.",
  "forecastModels.forecastModelScopeRegional": "Regional",
  "forecastModels.forecastModelScopeRegionalDescription": "Denna modell täcker endast en specifik region.",
  "forecastModels.forecastModelSpecifications": "Specifikationer",
  "forecastModels.forecastNoPinLocation": "Ingen föredragen modell når den här platsen — ”överallt annars” avgör.",
  "forecastModels.forecastNoPinStation": "Ingen föredragen modell når den här stationen — ”överallt annars” avgör.",
  "forecastModels.forecastNoPreferredModels": "Inga föredragna modeller angivna ännu.",
  "forecastModels.forecastOverrideElsewhere": "Dina inställningar gäller överallt annars.",
  "forecastModels.forecastPickForLocation": "Eller välj en för den här platsen",
  "forecastModels.forecastPickForStation": "Eller välj en för den här stationen",
  "forecastModels.forecastPinWinsLocation": "{model} — din första föredragna modell som når den här platsen.",
  "forecastModels.forecastPinWinsStation": "{model} — din första föredragna modell som når den här stationen.",
  "forecastModels.forecastServedNowHere": "Just nu är det {model} här",
  "forecastModels.forecastSetForLocation": "Angiven för den här platsen",
  "forecastModels.forecastSetForStation": "Angiven för den här stationen",
  "forecastModels.forecastSettingsRowSub": "Föredragna modeller, och vad som gäller överallt annars",
  "forecastModels.forecastStopUsingHere": "Sluta använda här",
  "forecastModels.forecastUseForLocation": "Använd {model} för den här platsen",
  "forecastModels.forecastUseForStation": "Använd {model} för den här stationen",
  "forecastModels.forecastUsePreferred": "Använd mina föredragna modeller",
  "forecastModels.frequencyHourly": "Varje timme",
  "forecastModels.horizon": "Horisont",
  "forecastModels.horizonValue": "upp till {value} timmar",
  "forecastModels.meshSize": "Rasterstorlek",
  "forecastModels.pickerShowAll": "Visa hela katalogen",
  "forecastModels.pickerUnreachable": "{count, plural, one {# modell till når} other {# modeller till når}} ingen av dina stationer",
  "forecastModels.pinInUse": "Används",
  "forecastModels.pinShadowed": "Används aldrig — en modell ovanför täcker alla dina stationer",
  "forecastModels.pinSlots": "{used} av {max} · välj en modell",
  "forecastModels.pinSlotsFull": "{max, plural, one {Den enda platsen används. Ta bort dess modell för att lägga till en annan.} other {Alla # platser används. Ta bort en för att lägga till en annan.}}",
  "forecastModels.pinsUncoveredCount": "{used} av dina {count, plural, one {# station} other {# stationer}}: ingen föredragen modell når {used, plural, one {den} other {dem}} — ”överallt annars” avgör.",
  "forecastModels.pinsUncoveredNamed": "{stations}: ingen föredragen modell når {count, plural, one {den} other {dem}} — ”överallt annars” avgör.",
  "forecastModels.pinUnreachable": "Används aldrig — den når ingen av dina stationer",
  "forecastModels.pinUsedAt": "Används vid {stations}",
  "forecastModels.pinUsedAtAll": "{count, plural, one {Används vid din station} other {Används vid alla # stationer}}",
  "forecastModels.pinUsedAtSome": "Används vid {used} av {count, plural, one {# station} other {# stationer}}",
  "forecastModels.preferredModels": "Föredragna modeller",
  "forecastModels.preferredModelsAll": "En lista, alla stationer",
  "forecastModels.preferredModelsOne": "En lista, gäller överallt",
  "forecastModels.publisher": "Utgivare",
  "forecastModels.removePreferredModel": "Ta bort {model} från dina föredragna modeller",
  "forecastModels.resetForecastPreference": "Återställ",
  "forecastModels.resetForecastPreferenceHint": "Rensar dina föredragna modeller och återgår till SmartMixins standard.",
  "forecastModels.servedNowMany": "Just nu: GFS {count, plural, one {vid din station} other {vid alla # stationer}}.",
  "forecastModels.servedNowNone": "Just nu: GFS överallt.",
  "forecastModels.title_SMARTMIXIN_MULTIMODEL": "SmartMixin multimodell",
  "forecastModels.title_WEATHERFLOW_FORECAST": "Weatherflow-prognos",
  "forecastModels.weatherForecastModels": "Väderprognosmodeller",
  "helpCenter.articleCount": "{count, plural, one {# artikel} other {# artiklar}}",
  "helpCenter.articleNotFound": "Artikeln hittades inte",
  "helpCenter.articleNotFoundDescription": "Artikeln du letar efter finns inte.",
  "helpCenter.backToHelpCenter": "Tillbaka till hjälpcentret",
  "helpCenter.browseByCategory": "Bläddra efter kategori",
  "helpCenter.categoryNotFound": "Kategori hittades inte",
  "helpCenter.categoryNotFoundDescription": "Denna kategori finns inte eller har inga artiklar.",
  "helpCenter.contactSupport": "Kontakta support",
  "helpCenter.feedbackHelpsImprove": "Din feedback hjälper oss att förbättra våra hjälpartiklar.",
  "helpCenter.feedbackReasonNotAnswer": "Den besvarar inte min fråga",
  "helpCenter.feedbackReasonOutdated": "Informationen är föråldrad",
  "helpCenter.feedbackReasonUnclear": "Instruktionerna är otydliga",
  "helpCenter.feedbackWhatWentWrong": "Vad var problemet?",
  "helpCenter.helpCategoryAccount": "Konto",
  "helpCenter.helpCategoryBilling": "Fakturering",
  "helpCenter.helpCategoryForecast": "Prognoser",
  "helpCenter.helpCategoryGettingStarted": "Kom igång",
  "helpCenter.helpCategoryProviders": "Leverantörer",
  "helpCenter.helpCategoryStations": "Stationer",
  "helpCenter.helpCategoryTroubleshooting": "Felsökning",
  "helpCenter.helpCenter": "Hjälpcenter",
  "helpCenter.landingDescription": "Hitta svar på vanliga frågor och lär dig hur du får ut det mesta av SmartMixin.",
  "helpCenter.linkToSection": "Länk till det här avsnittet",
  "helpCenter.menuItemDescription": "Vanliga frågor och guider",
  "helpCenter.minRead": "{minutes} min läsning",
  "helpCenter.onThisPage": "På den här sidan",
  "helpCenter.platformMobileApp": "Mobilapp",
  "helpCenter.platformMobileOnly": "Endast i mobilappen",
  "helpCenter.platformWebApp": "Webbapp",
  "helpCenter.platformWebOnly": "Endast i webbappen",
  "helpCenter.popularArticles": "Populära artiklar",
  "helpCenter.relatedArticles": "Relaterade artiklar",
  "helpCenter.searchArticles": "Sök artiklar...",
  "helpCenter.stillNeedHelp": "Behöver du fortfarande hjälp?",
  "helpCenter.stillNeedHelpDescription": "Om den här artikeln inte besvarade din fråga hjälper jag dig gärna direkt.",
  "helpCenter.supportEmailSubject": "SmartMixin-hjälp",
  "helpCenter.supportEmailSubjectTopic": "SmartMixin-hjälp — {topic}",
  "helpCenter.thankYouForFeedback": "Tack för din feedback!",
  "helpCenter.wasArticleHelpful": "Var denna artikel till hjälp?",
  "intro.locationDescription": "Aktivera platsåtkomst för att få exakta väderprognoser anpassade till ditt exakta område — inga generiska prognoser längre.",
  "intro.locationTitle": "Prognoser skapade för dig",
  "intro.notificationDescription": "Slå på aviseringar för att få snabba varningar om väderförändringar som är viktiga för dig — regn, snö eller allvarliga förhållanden, precis när du behöver veta.",
  "intro.notificationsTitle": "Missa aldrig en väderförändring",
  "intro.readyDescription": "Njut av precisa prognoser, realtidsväderinsikter och stationsdata från hela världen — allt i en kraftfull app.",
  "intro.readyTitle": "Du är redo!",
  "intro.welcomeDescription": "Få hyperlokala prognoser från toppväderbyråer — plus tillgång till över 40 000 väderstationer världen över för att se verkliga förhållanden, både historiska och aktuella.",
  "intro.welcomeTitle": "Ditt väder, omdefinierat",
  "landing.alsoAvailableOn": "Finns även på:",
  "landing.featureAlertsDescription": "Ställ in egna tröskelvärden för alla mätvärden. Få en avisering när temperaturen sjunker, regnet börjar eller vinden tilltar.",
  "landing.featureAlertsTitle": "Smarta varningar",
  "landing.featureAnalyticsDescription": "Interaktiva diagram, trendanalys och detaljerad statistik. Fördjupa dig i data om temperatur, luftfuktighet, lufttryck, regn och vind.",
  "landing.featureAnalyticsTitle": "Avancerad analys",
  "landing.featureExportDescription": "Få alla dina väderdata via e-post som ett Excel-kalkylark, redo för vidare analys i Excel, Google Kalkylark eller dina favoritverktyg.",
  "landing.featureExportTitle": "Exportera dina data",
  "landing.featureForecastDescription": "Få tillgång till {count, plural, one {#+ professionell prognosmodell} other {#+ professionella prognosmodeller}}, bland annat ECMWF, GFS och regionala modeller. Jämför dem sida vid sida och gör dina egna prognoser.",
  "landing.featureForecastTitle": "Jämför prognosmodeller",
  "landing.featureHistoryDescription": "Få tillgång till historiska data med tim-, dags- och månadsskala. Exportera dem till Excel för forskning eller personliga arkiv.",
  "landing.featureHistoryTitle": "Rik historik",
  "landing.featureMultiBrandDescription": "Anslut Netatmo, Davis, Tempest, Ecowitt, Ambient Weather och fler. Slut på att växla mellan appar.",
  "landing.featureMultiBrandTitle": "Alla märken, en app",
  "landing.featuresSubtitle": "SmartMixin ger dig verktygen för att analysera, jämföra och förstå dina väderdata som ett proffs.",
  "landing.featuresTitle": "Byggt för dataälskare",
  "landing.finalCtaButton": "Skapa gratis konto",
  "landing.finalCtaSubtitle": "Anslut dig till tusentals väderentusiaster som litar på SmartMixin.",
  "landing.finalCtaTitle": "Redo att dyka djupare in i dina väderdata?",
  "landing.heroCta": "Börja gratis",
  "landing.heroDescription": "Djupgående analys, snygga diagram och professionella prognoser — alla dina väderstationer samlade i en kraftfull app.",
  "landing.heroSecondaryCta": "Utforska kartan",
  "landing.heroTagline": "För väderentusiaster",
  "landing.heroTitle": "Se ditt väder som aldrig förr",
  "landing.pricingComparisonCaption": "Jämförelse av funktioner i Gratis och Premium",
  "landing.pricingFeatureAdvancedMetrics": "Avancerade mätningar",
  "landing.pricingFeatureAlerts": "Anpassade varningar",
  "landing.pricingFeatureColumn": "Funktion",
  "landing.pricingFeatureExport": "Dataexport (Excel)",
  "landing.pricingFeatureForecastComparison": "Prognosjämförelse",
  "landing.pricingFeatureForecasts": "Prognosmodeller",
  "landing.pricingFeatureForecastsFreeTier": "1 modell",
  "landing.pricingFeatureForecastsPremiumTier": "{count, plural, one {#+ modell} other {#+ modeller}}",
  "landing.pricingFeatureReports": "Analyser & rapporter",
  "landing.pricingFeatureStationComparison": "Stationsjämförelse",
  "landing.pricingFeatureWidgets": "Hemskärmswidgetar",
  "landing.pricingFeatureYearOverYear": "Årsjämförelse",
  "landing.pricingFreeCta": "Kom igång",
  "landing.pricingFreePrice": "0 €",
  "landing.pricingMostPopular": "Mest populär",
  "landing.pricingPremiumCta": "Kom igång",
  "landing.pricingPremiumDescription": "Från 1,99 €/månad — prenumerera på webben, App Store eller Google Play",
  "landing.pricingSubtitle": "Börja gratis, uppgradera när du behöver mer.",
  "landing.pricingTitle": "Enkel, transparent prissättning",
  "landing.statBrands": "Stödda varumärken",
  "landing.statForecasts": "Prognosmodeller",
  "landing.statStations": "Väderstationer",
  "landing.supportedDevicesNote": "Plus över {count, number} offentliga stationer från Världsmeteorologiska organisationens nätverk",
  "landing.supportedDevicesSubtitle": "Anslut din befintliga väderstation på några minuter. Vi stöder {count, plural, one {# stort märke} other {# stora märken}}, och fler tillkommer.",
  "landing.supportedDevicesTitle": "Fungerar med din station",
  "metrics.absolutePressure": "Absolut tryck",
  "metrics.airDensity": "Luftdensitet",
  "metrics.airGap": "Luftspalt",
  "metrics.apparentTemperature": "Upplevd temperatur",
  "metrics.AQI": "AQI",
  "metrics.AQI_24H": "24h AQI",
  "metrics.avg": "Genomsnitt",
  "metrics.avg_wind": "Genomsnittlig vindstyrka",
  "metrics.beaufort": "Beaufort",
  "metrics.blackGlobeTemperature": "Svartkuletemperatur",
  "metrics.boilerOn": "Värme på",
  "metrics.boilerOnInHours": "Värme på (timmar)",
  "metrics.cloudCover": "Molntäcke",
  "metrics.co2": "CO2",
  "metrics.conductivity": "Konduktivitet",
  "metrics.dailyPrecipitation": "Dygnsnederbörd",
  "metrics.dailyRain": "Daglig nederbörd",
  "metrics.degreeDayShort": "GD",
  "metrics.depth": "Djup",
  "metrics.depthSensors": "Djupsensorer",
  "metrics.dewPoint": "Daggpunkt",
  "metrics.distance": "Avstånd",
  "metrics.downTrend": "Nedåtgående trend",
  "metrics.ET": "Evapotranspiration",
  "metrics.etToday": "ET i dag",
  "metrics.feelsLike": "Känns som",
  "metrics.feelsLikeWithFormula": "Känns som ({formula})",
  "metrics.frostPoint": "Frostpunkt",
  "metrics.gust": "Vindbyar",
  "metrics.gustDirection": "Vindbyarnas riktning",
  "metrics.hail": "Hagel",
  "metrics.heatIndex": "Värmeindex",
  "metrics.heatingDegreeDays": "Uppvärmningsgraddagar",
  "metrics.heatingPower": "Värmeeffekt",
  "metrics.humidex": "Humidex",
  "metrics.humidity": "Luftfuktighet",
  "metrics.lastLightningImpact": "Sista blixtnedslaget",
  "metrics.lastMeasure": "Senaste mätning",
  "metrics.leafSensors": "Bladsensorer",
  "metrics.leafWetness": "Bladvåthet",
  "metrics.lightningDistance": "Avstånd",
  "metrics.lightningStrikeCount": "Antal blixtnedslag",
  "metrics.lightningStrikeDistance": "Blixtnedslagsavstånd",
  "metrics.max": "Max.",
  "metrics.max_gust": "Max. vindbyar",
  "metrics.maxToday": "Max i dag",
  "metrics.min": "Min.",
  "metrics.noise": "Ljudnivå",
  "metrics.normalizedHeatingCoefficient": "Normaliserad värmekoefficient",
  "metrics.outdoorTemperature": "Utetemperatur",
  "metrics.PM_1": "PM 1",
  "metrics.PM_10": "PM 10",
  "metrics.PM_2P5": "PM 2,5",
  "metrics.precipitation": "Nederbörd",
  "metrics.pressure": "Lufttryck",
  "metrics.rain": "Nederbörd",
  "metrics.rainDurationValue": "Regnvaraktighet: {duration}",
  "metrics.rainfallMeasurement": "Regnmätning",
  "metrics.rainRate": "Regnintensitet",
  "metrics.relativePressure": "Relativt tryck",
  "metrics.setPoint": "Börvärde",
  "metrics.snow": "Snö",
  "metrics.snowfall": "Snöfall",
  "metrics.soilMoisture": "Markfuktighet",
  "metrics.soilSensors": "Marksensorer",
  "metrics.soilWaterTension": "Markvattenspänning",
  "metrics.solarEnergy": "Solenergi",
  "metrics.solarRadiation": "Solstrålning",
  "metrics.speed": "Hastighet",
  "metrics.stableTrend": "Stabil trend",
  "metrics.sum": "Summa",
  "metrics.temperature": "Temperatur",
  "metrics.temperatureSensors": "Temperatur/fuktighetsgivare",
  "metrics.temperatureShort": "Temp.",
  "metrics.thsw": "THSW",
  "metrics.thw": "THW",
  "metrics.upTrend": "Upptrend",
  "metrics.uv": "UV",
  "metrics.visibility": "Sikt",
  "metrics.weatherCondition": "Väderförhållanden",
  "metrics.wetBulbGlobeTemperature": "Våtkuletemperatur",
  "metrics.wetBulbTemperature": "Våttemperatur",
  "metrics.wind": "Vind",
  "metrics.windChill": "Vindens kyleffekt",
  "metrics.windDirection": "Vindriktning",
  "metrics.windMeasurement": "Vindmätning",
  "metrics.windRun": "Vindsträcka",
  "metrics.windRunDescription": "Vindsträckan är den totala sträcka som vinden färdas under en tidsperiod",
  "metrics.windSpeed": "Vindhastighet",
  "navigation.allFavorites": "Visa alla",
  "navigation.breadcrumbs": "Brödsmulor",
  "navigation.collapseNavigation": "Fäll ihop navigeringen",
  "navigation.expandNavigation": "Fäll ut navigeringen",
  "navigation.main": "Huvudmeny",
  "navigation.mapShort": "Karta",
  "navigation.skipToContent": "Hoppa till huvudinnehållet",
  "navigation.stationsShort": "Stationer",
  "network.cancelError": "Förfrågan avbruten",
  "network.connectionError": "Anslutningsfel",
  "network.networkError": "Nätverk ej tillgängligt",
  "network.serverError": "Ett problem uppstod ...",
  "network.timeoutError": "Timeout-fel",
  "network.unknownError": "Okänt fel",
  "premium.alreadyPremium": "Du har redan ett premiumkonto!",
  "premium.bestValue": "Mest prisvärd",
  "premium.billingDetailsAndroid": "Gratis provperiod: du debiteras inte om du säger upp minst 24 timmar innan provperioden slutar. Därefter förnyas din SmartMixin-prenumeration automatiskt om du inte säger upp den minst 24 timmar före slutet av den aktuella perioden; du kan säga upp den när som helst i inställningarna för ditt Google Play-konto. Varje förnyelse debiteras till det pris som visas på knappen ovan. Betalningen debiteras ditt Google Play-konto när du bekräftar köpet och i början av varje förnyelseperiod.",
  "premium.billingDetailsIos": "Gratis provperiod: du debiteras inte om du säger upp minst 24 timmar innan provperioden slutar. Därefter förnyas din SmartMixin-prenumeration automatiskt om du inte säger upp den minst 24 timmar före slutet av den aktuella perioden; du kan säga upp den när som helst i inställningarna för ditt App Store-konto. Varje förnyelse debiteras till det pris som visas på knappen ovan. Betalningen debiteras ditt App Store-konto när du bekräftar köpet och i början av varje förnyelseperiod.",
  "premium.freeBannerBody": "Gratiskonton får GFS överallt — dina föredragna modeller och ”överallt annars” börjar gälla så snart du prenumererar.",
  "premium.freeBannerTitle": "Inställningarna gäller med Premium",
  "premium.freeSubscription": "Gratis premiumprenumeration",
  "premium.freeTrialForPeriod": "Gratis provperiod i {period, plural, one {# dag} other {# dagar}}",
  "premium.getUnlimitedAccess": "Obegränsad tillgång till:",
  "premium.manageMySubscription": "Hantera min prenumeration",
  "premium.notPurchasedYet": "Inget köp av SmartMixin Premium hittades för det här butikskontot.",
  "premium.orChooseMonthly": "Eller välj månadsvis:",
  "premium.premium": "SmartMixin Premium",
  "premium.premiumActive": "Aktiv",
  "premium.premiumAnnualTrialInfo": "Börja med en gratis provperiod på {days, plural, one {# dag} other {# dagar}}",
  "premium.premiumCurrentPlan": "Nuvarande abonnemang",
  "premium.premiumDownloadApp": "Ladda ner appen för att prenumerera:",
  "premium.premiumEndsOn": "Upphör {date}",
  "premium.premiumFeatureAlerts": "Vädervarningar",
  "premium.premiumFeatureAnalysis": "Avancerad väderanalys",
  "premium.premiumFeatureCharts": "Diagramjämförelser",
  "premium.premiumFeatureExport": "Dataexport",
  "premium.premiumFeatureForecast": "Regionala prognosmodeller",
  "premium.premiumFeatureNotification": "Statusfältswidget",
  "premium.premiumFeatureTitle": "Premiumfunktion",
  "premium.premiumFeatureWidgets": "Hemskärmswidgetar",
  "premium.premiumFreePlan": "Gratis",
  "premium.premiumInactive": "Inte prenumerant",
  "premium.premiumManageStoreSubscription": "Du prenumererar via {store}. Hantera eller säg upp prenumerationen där.",
  "premium.premiumManageWebSubscription": "Hantera din prenumeration, uppdatera betalningsmetod eller avsluta.",
  "premium.premiumPremiumPlan": "Premium",
  "premium.premiumRenewsOn": "Förnyas {date}",
  "premium.premiumSubscribeAnnual": "Årsvis — 9,99 €/år",
  "premium.premiumSubscribedOn": "Prenumererad på {platform}",
  "premium.premiumSubscribedOnWeb": "Prenumererar via webben",
  "premium.premiumSubscribeMonthly": "Månadsvis — 1,99 €/månad",
  "premium.premiumSubscribeOnWeb": "Prenumerera nu för att låsa upp alla premiumfunktioner.",
  "premium.premiumSubscriptionSuccess": "Din prenumeration har aktiverats! Njut av alla premiumfunktioner.",
  "premium.premiumSubscriptionSuccessTitle": "Välkommen till Premium!",
  "premium.premiumWebappNotice": "Det går inte att prenumerera på webben just nu.",
  "premium.pricePerMonth": "{price}/månad",
  "premium.pricePerYear": "{price}/år",
  "premium.purchasedNetatmoPro": "Du har tidigare köpt Netatmo Pro ({date}). Det ger dig tillgång till en del av premiumfunktionerna. Prenumerera på något av erbjudandena nedan om du vill få tillgång till alla premiumfunktioner.",
  "premium.purchaseFailed": "Köpet kunde inte slutföras. Försök igen.",
  "premium.restoreFailed": "Dina köp kunde inte återställas. Försök igen.",
  "premium.restorePurchase": "Återställ köpet",
  "premium.savingsPercent": "Spara {percent}%",
  "premium.seePremium": "Se Premium",
  "premium.startFreeTrial": "Starta gratis provperiod",
  "premium.storeUnavailable": "Butiken är inte tillgänglig just nu. Försök igen senare.",
  "premium.subscribeNow": "Prenumerera nu — utan provperiod",
  "premium.switchToPremium": "Byt till SmartMixin Premium",
  "premium.thenPrice": "sedan {price}",
  "providerHints.ambientWeatherApiKey": "Skapad i kontoinställningarna på ambientweather.net.",
  "providerHints.davisApiSecret": "Visas endast en gång när du skapade V2 API-nyckeln — förvara säkert.",
  "providerHints.davisV2ApiKey": "Från sidan med V2 API-nycklar på weatherlink.com.",
  "providerHints.ecowittApi": "Från API-sidan i ditt Ecowitt-konto.",
  "providerHints.ecowittApp": "Applikationsnyckeln, också från ditt Ecowitt-konto.",
  "providerHints.myAcuriteCredentialsBanner": "Använd e-post och lösenord till ditt My AcuRite-konto — inte SmartMixin-inloggningen.",
  "providerHints.myAcuriteEmail": "E-postadressen till ditt My AcuRite-konto — inte din SmartMixin-inloggning.",
  "providerHints.myAcuritePassword": "Lösenordet till ditt My AcuRite-konto.",
  "providerHints.weatherflowToken": "Personlig token från tempestwx.com → inställningar → dataauktoriseringar.",
  "providerHints.wundergroundEditKey": "Använd en annan nyckel",
  "providerHints.wundergroundKey": "En lång sträng från API-nyckelsidan i ditt Weather Underground-konto — inte ditt wunderground.com-lösenord.",
  "providerHints.wundergroundKeyExample": "t.ex. 5f6a7b8c9dabcdef…",
  "providerHints.wundergroundKeyVerified": "API-nyckel verifierad",
  "providerHints.wundergroundNoStationsNearby": "Inga stationer hittades nära den här platsen. Försök att ange ett stations-ID direkt.",
  "providerHints.wundergroundStationIdExample": "t.ex. KCASANFR123",
  "providerIntro.ambientWeatherStep2": "Hämta din Ambient Weather API-nyckel.",
  "providerIntro.davisStep2": "Hämta din Davis V2 API-nyckel och API-hemlighet.",
  "providerIntro.ecowittStep2": "Hämta din Ecowitt API-nyckel och applikationsnyckel.",
  "providerIntro.getStarted": "Kom igång",
  "providerIntro.myAcuriteStep2": "Använd e-post och lösenord till ditt befintliga My AcuRite-konto.",
  "providerIntro.netatmoEnergyStep2": "Logga in på Netatmo när du uppmanas — ingen API-nyckel behövs.",
  "providerIntro.netatmoWeatherStep2": "Logga in på Netatmo när du uppmanas — ingen API-nyckel behövs.",
  "providerIntro.signupBanner": "Nästan klart — skapa ditt kostnadsfria SmartMixin-konto för att ansluta {provider}.",
  "providerIntro.step1": "Logga in på ditt SmartMixin-konto (INTE din {provider}-inloggning).",
  "providerIntro.step3EmailPassword": "Ange dem här.",
  "providerIntro.step3KeyOrToken": "Klistra in här.",
  "providerIntro.step3OAuth": "Godkänn SmartMixin i popup-fönstret.",
  "providerIntro.step3Wunderground": "Klistra in din API-nyckel och välj sedan en station i närheten eller ange ett valfritt stations-ID.",
  "providerIntro.stepOfTotal": "Steg {step} av {total}",
  "providerIntro.title": "Anslut {provider}",
  "providerIntro.weatherflowStep2": "Hämta din personliga Tempest-token.",
  "providerIntro.wundergroundBrowsePublic": "Har du ingen station? Bläddra bland offentliga",
  "providerIntro.wundergroundFindNearby": "Hitta stationer i närheten",
  "providerIntro.wundergroundOrEnterId": "Eller ange ett stations-ID",
  "providerIntro.wundergroundStep2": "Hämta din Weather Underground API-nyckel. Sedan kan du ansluta vilken station som helst — din egen eller en offentlig.",
  "reports.agroMeteorology": "Agrometeorologi",
  "reports.analysis": "Analys",
  "reports.annualCumulativeRainfallComparison": "Jämförelse av totala årliga nederbördsmängder",
  "reports.annualHeatingDurationComparison": "Årlig jämförelse av uppvärmningstid",
  "reports.annualHeatingEfficiency": "Årlig uppvärmningseffektivitet",
  "reports.annualIndoorComparison": "Årlig inomhusjämförelse",
  "reports.annualOutdoorComparison": "Årlig utomhusjämförelse",
  "reports.annualOutdoorReport": "Årsrapport utomhus",
  "reports.annualReport": "Årsrapport",
  "reports.annualSolarReport": "Årlig solrapport",
  "reports.annualWaterBalance": "Årlig vattenbalans",
  "reports.annualWaterBalanceCarryOver": "Överför {year} ({value})",
  "reports.annualWaterBalanceDescription": "En vattenbalans (förenklad version, endast regn och evapotranspiration används) gör det möjligt att hantera vattenresursen",
  "reports.avgHumidity": "Genomsnittlig luftfuktighet",
  "reports.avgMaxTemperature": "Genomsnitt T°max",
  "reports.avgMetric": "Genomsnittlig {metric}",
  "reports.avgMinTemperature": "Genomsnitt T°min",
  "reports.avgPressure": "Genomsnittligt lufttryck",
  "reports.avgTemperature": "Medeltemperatur",
  "reports.chartsAndTable": "Diagram och tabell",
  "reports.climateNormalPeriodOfRecord": "Mätperiod ({years} år)",
  "reports.climateNormals": "Klimatnormaler",
  "reports.climateNormalStandardLabel": "Standardnormal ({period})",
  "reports.climateTrendPerDecade": "Temperaturtrend: {value} per decennium under {years} år",
  "reports.coldestMonthRanking": "Kallaste {month} som uppmätts",
  "reports.comfortable": "Lagom (45% {lessThan} luftfuktighet ≤ 60%)",
  "reports.cumulativeRainfall": "Kumulativ nederbörd",
  "reports.cumulativeRainfallDescription": "Följ den totala nederbörden som ackumuleras under den valda perioden.",
  "reports.dailyMaxRainfall": "Daglig max nederbörd",
  "reports.dataExport": "Exportera data",
  "reports.dataExportXlsxFormatDescription": "Exportera alla stationens data i Excel-format (* .xlsx). När du klickar på knappen får du ett e-mail med bearbetade data efter några minuter.",
  "reports.daysOfData": "{days, plural, one {# dags data} other {# dagars data}}",
  "reports.daysWithFrost": "Dagar med frost",
  "reports.daysWithHeavyRain": "Dagar med kraftigt regn (≥ {threshold})",
  "reports.daysWithoutThaw": "Dagar utan töväder",
  "reports.daysWithStrongFrost": "Dagar med stark frost",
  "reports.emailSent": "Ett e-mail har skickats till dig",
  "reports.frostDays": "Frostdagar",
  "reports.grasslandTemperatureSum": "Summan av gräsmarkstemperaturer",
  "reports.grasslandTemperatureSumDescription": "Hållbar återhämtning av vegetationen när summan når {threshold}",
  "reports.growingDegreeDays": "Tillväxtgraddagar",
  "reports.highPressure": "Högtryck (tryck ≥ {threshold})",
  "reports.iceDays": "Isdagar",
  "reports.indoorReport": "Inomhusrapport",
  "reports.keyFacts": "Viktiga fakta",
  "reports.longestDrySpell": "Längsta torrperiod",
  "reports.longestRunOfRainyDays": "Antal på varandra följande regniga dagar",
  "reports.longestRunWithoutRun": "Antal på varandra följande dagar utan regn",
  "reports.longestWetSpell": "Längsta nederbördsperiod",
  "reports.lowPressure": "Lågtryck (tryck {lessThan} {threshold})",
  "reports.maxHumidity": "Högsta luftfuktighet",
  "reports.maxMetric": "Högsta {metric}",
  "reports.maxPressure": "Högsta lufttryck",
  "reports.maxTemperature": "Högsta temperatur",
  "reports.maxTempGreaterThan": "T°max ≥",
  "reports.maxTempMagnitude24h": "Variation max (/24H)",
  "reports.minHumidity": "Lägsta luftfuktighet",
  "reports.minMetric": "Lägsta {metric}",
  "reports.minPressure": "Lägsta lufttryck",
  "reports.minTemperature": "Lägsta temperatur",
  "reports.minTempMagnitude24h": "Variation min (/24H)",
  "reports.monthlyAverageCountdown": "{days, plural, one {# dag till} other {# dagar till}} den här månaden",
  "reports.monthlyAverageCountdownDetail": "Då visas månadens medelvärde och placering.",
  "reports.monthlyAverageRule": "Månadsmedelvärden och placeringar visas när en kalendermånad har {days, plural, one {# registrerad dag} other {# registrerade dagar}}.",
  "reports.monthlyHeatingEfficiency": "Månatlig värmeeffektivitet",
  "reports.monthlyOutdoorReport": "Månadsrapport utomhus",
  "reports.monthlyReport": "Månadsrapport",
  "reports.monthlySolarReport": "Månatlig solrapport",
  "reports.monthlyWindReport": "Månadsrapport vind",
  "reports.monthsOfData": "{months} månaders data",
  "reports.numberOfDays": "Antal dagar",
  "reports.onThisDayChartRule": "Diagrammet år för år visas när {count, plural, one {# år} other {# år}} av {date} har registrerats.",
  "reports.onThisDayChartSummary": "{years, plural, one {# år} other {# år}} med temperatur, {first} till {last}. Värmerekord {high} år {highYears}, köldrekord {low} år {lowYear}. Normal dag {min} till {max}.",
  "reports.onThisDayCoverage": "{years, plural, one {# år sedan {firstYear}} other {# år sedan {firstYear}}}",
  "reports.onThisDayDataSince": "Den här stationen har data sedan {date}.",
  "reports.onThisDayEveryYear": "Varje {date} i arkivet",
  "reports.onThisDayGapNoData": "inga data",
  "reports.onThisDayInHistory": "Denna dag i historien",
  "reports.onThisDayLeaveOk": "Du kan lämna den här skärmen; inläsningen fortsätter.",
  "reports.onThisDayLoadFailed": "Det gick inte att läsa in {date}. Kontrollera anslutningen och försök igen.",
  "reports.onThisDayNoDataRun": "{start}–{end} · inga data ({count, plural, one {# år} other {# år}})",
  "reports.onThisDayNormal": "Normal dag: {min} till {max}",
  "reports.onThisDayNoYears": "Ingen fullständig {date} registrerad än",
  "reports.onThisDayNoYearsDetail": "Sidan fylls på från den första {date} som stationen registrerar fullt ut.",
  "reports.onThisDayNoYearSelected": "Inget år valt",
  "reports.onThisDayOneReading": "1 mätning",
  "reports.onThisDayOneReadingSummary": "{year}: {value}, 1 mätning, nederbörd {rain}",
  "reports.onThisDayOpenRecords": "Öppna Rekord och klimat",
  "reports.onThisDayPickHint": "Ändrar dagen som visas",
  "reports.onThisDayPickTitle": "Välj en dag",
  "reports.onThisDayRain": "Nederbörd den {date}",
  "reports.onThisDayRainNotMeasured": "inte uppmätt",
  "reports.onThisDayRainOnlySummary": "{year}: nederbörd {rain}",
  "reports.onThisDayRainSince": "nederbörd sedan {year}",
  "reports.onThisDayRainSummary": "Nederbörd den {date}. Regnigaste dag {value} år {years}.",
  "reports.onThisDayRetry": "Försök igen",
  "reports.onThisDaySingleReading": "{count, plural, one {# år har} other {# år har}} bara en mätning den dagen och visas inte.",
  "reports.onThisDaySlowLoad": "Läser {years, plural, one {# år} other {# år}} för {date}. Första gången ett datum hämtas kan det ta upp till 20 sekunder.",
  "reports.onThisDaySlowLoadGeneric": "Läser stationens historik för {date}. Första gången ett datum hämtas kan det ta upp till 20 sekunder.",
  "reports.onThisDayTied": "tangerat {years}",
  "reports.onThisDayTiedMore": "tangerat {years} +{count}",
  "reports.onThisDayYearSummary": "{year}: lägsta {min}, högsta {max}, nederbörd {rain}",
  "reports.onThisDayYearTied": "{year} ({tied})",
  "reports.outdoorReport": "Utomhusrapport",
  "reports.overviewSection": "Översikt",
  "reports.rainfall": "Nederbörd",
  "reports.rainyDays": "Regniga dagar",
  "reports.recordClimatologicalDay": "Klimatologiskt dygn (06–06 UTC)",
  "reports.recordClimDayBody": "Här summeras nederbörden per kalenderdygn, från midnatt till midnatt på stationen. Vädertjänster summerar den från 06:00 till 06:00 UTC, så ett oväder runt midnatt kan göra en annan dag till den regnigaste.",
  "reports.recordDailyRain": "Regnigaste dag",
  "reports.recordFromHourlyReadings": "Från timavläsningar",
  "reports.recordHigh": "Värmerekord",
  "reports.recordLow": "Köldrekord",
  "reports.recordOfficialBody": "Vädertjänsten publicerar en daglig högsta och lägsta temperatur för den här stationen, avläst på max- och mintermometrar. De fångar korta toppar som timavläsningarna missar och ersätter därför värdena som beräknats från timavläsningarna.",
  "reports.recordOfficialValue": "Officiellt värde",
  "reports.recordsAndClimatology": "Rekord och klimat",
  "reports.recordSheetTitle": "Om dessa rekord",
  "reports.recordsSince": "Rekord sedan {date}",
  "reports.recordWindGust": "Kraftigaste vindby",
  "reports.relativelyWet": "Relativt fuktigt (60% {lessThan} luftfuktighet ≤ 80%)",
  "reports.sectionReportCount": "{count, plural, one {# rapport} other {# rapporter}}",
  "reports.sendEmail": "Skicka e-post",
  "reports.summerDays": "Sommardagar",
  "reports.tableScrollRegion": "{title}, rullar vågrätt",
  "reports.tooDry": "För torr (luftfuktighet ≤ 45%)",
  "reports.tooWet": "För hög fuktighet (luftfuktighet {greaterThan} 80%)",
  "reports.tropicalNights": "Tropiska nätter",
  "reports.unlockPremiumSubtitle": "Ingår i SmartMixin Premium",
  "reports.unlockPremiumTitle": "Lås upp {count, plural, one {# premiumfunktion} other {# premiumfunktioner}}",
  "reports.warmestMonthRanking": "Varmaste {month} som uppmätts",
  "reports.waterBalance": "Vattenbalans",
  "reports.yearsOfData": "{years} års data",
  "reports.yearToDateTemperatureComparison": "Temperaturjämförelse hittills i år",
  "sensors.bgtSensors": "Svartkula & WBGT",
  "sensors.cameraFeed": "Kamera",
  "sensors.compareHumidity": "Jämför luftfuktighet",
  "sensors.compareMoisture": "Jämför markfukt",
  "sensors.comparePm25": "Jämför PM2.5",
  "sensors.compareTemperatures": "Jämför temperaturer",
  "sensors.compareWaterTension": "Jämför markvattenspänning",
  "sensors.depthByChannel": "Djup per kanal",
  "sensors.heatStressExtreme": "Extrem värmestress",
  "sensors.heatStressModerate": "Måttlig värmestress",
  "sensors.heatStressNone": "Ingen värmestress",
  "sensors.heatStressStrong": "Stark värmestress",
  "sensors.heatStressVeryStrong": "Mycket stark värmestress",
  "sensors.indoorClimate": "Inomhusklimat",
  "sensors.indoorCo2Levels": "CO2-nivåer",
  "sensors.indoorTemperatureAndHumidity": "Temperatur och luftfuktighet",
  "sensors.leafWetnessByChannel": "Bladfuktighet per kanal",
  "sensors.lightningSensor": "Blixt",
  "sensors.moistureByChannel": "Markfukt per kanal",
  "sensors.noDataAvailable": "Ingen data tillgänglig",
  "sensors.pm10AndAqi": "PM10 & AQI",
  "sensors.pm1AndAqi": "PM1.0 & AQI",
  "sensors.pm25AndAqi": "PM2.5 & AQI",
  "sensors.pm25ByChannel": "PM2.5 per kanal",
  "sensors.pm4AndAqi": "PM4.0 & AQI",
  "sensors.selectChannel": "Välj kanal",
  "sensors.sensorDetailDescription": "Visa historiska data och trender för dina sensorkanaler.",
  "sensors.sensorHistory": "Sensorhistorik",
  "sensors.soilConductivityByChannel": "Konduktivitet per kanal",
  "sensors.soilTemperatureByChannel": "Marktemperatur per kanal",
  "sensors.strikesToday": "Nedslag idag",
  "sensors.temperatureByChannel": "Temperatur per kanal",
  "sensors.viewChart": "Visa diagram",
  "sensors.waterTensionByChannel": "Markvattenspänning per kanal",
  "settings.appearance": "Utseende",
  "settings.appVersion": "SmartMixin v{version}",
  "settings.arabic": "arabiska",
  "settings.bulgarian": "bulgariska",
  "settings.catalan": "katalanska",
  "settings.chartGestures": "Gester i diagram",
  "settings.chartGesturesDescription": "Svepning på diagram ändrar tidsperioden, nypa diagram ändrar tidsskala",
  "settings.choiceCount": "{count, plural, one {# tillgänglig} other {# tillgängliga}}",
  "settings.contactUs": "Kontakta oss",
  "settings.contactUsDescription": "Få hjälp eller skicka feedback",
  "settings.croatian": "kroatiska",
  "settings.czech": "tjeckiska",
  "settings.dailyDetailByPeriods": "Dagsdetaljer per period",
  "settings.dailyDetailByPeriodsDescription": "Gruppera de 24 timmarna i natt, morgon, eftermiddag och kväll — samma indelning som dagssammanfattningen använder.",
  "settings.danish": "danska",
  "settings.dark": "Mörkt tema",
  "settings.dataDisplay": "Datavisning",
  "settings.dateAndTime": "Datum och tid",
  "settings.donateButton": "Ge en donation",
  "settings.donateDescription": "SmartMixin är byggd av ett litet team. Om du har nytta av den kan du stödja utvecklingen med en engångsdonation på valfritt belopp. Det är en gåva — den ändrar inte ditt abonnemang och låser inte upp några funktioner.",
  "settings.donateSuccessBody": "Din donation hjälper till att hålla SmartMixin igång och göra den bättre. Vi uppskattar det verkligen.",
  "settings.donateSuccessTitle": "Tack för ditt stöd!",
  "settings.donateTitle": "Stöd SmartMixin",
  "settings.dragToReorder": "Dra för att ändra ordning",
  "settings.dutch": "nederländska",
  "settings.english": "engelska",
  "settings.french": "franska",
  "settings.german": "tyska",
  "settings.gestures": "Gester",
  "settings.greek": "grekiska",
  "settings.hungarian": "ungerska",
  "settings.italian": "italienska",
  "settings.japanese": "japanska",
  "settings.korean": "koreanska",
  "settings.language": "Språk",
  "settings.languageDescription": "Föredraget språk",
  "settings.light": "Ljust tema",
  "settings.mapTheme": "Karttema",
  "settings.mapThemeAuto": "Auto",
  "settings.mapThemeDark": "Mörk",
  "settings.mapThemeDescription": "Med Auto följer kartan appens tema.",
  "settings.mapThemeLight": "Ljus",
  "settings.measurementUnits": "Måttenheter",
  "settings.netatmoDashboard": "Netatmo-översikt",
  "settings.netatmoLayoutCards": "Kortlista",
  "settings.netatmoLayoutCardsDescription": "Ett kort per modul, allt i en scroll",
  "settings.netatmoLayoutClassic": "Klassisk",
  "settings.netatmoLayoutClassicDescription": "Två kort, växla mellan moduler",
  "settings.netatmoNewLayoutNotice": "Ny layout: ett kort per modul.",
  "settings.netatmoSwitchBackToClassic": "Tillbaka till klassisk",
  "settings.netatmoSwitchToLayout": "Byt till {layout}",
  "settings.norwegian": "norska",
  "settings.notificationsSection": "Aviseringar",
  "settings.ongoingNotificationEnabled": "Aktivera permanent avisering",
  "settings.ongoingNotificationMetrics": "Visade mätvärden",
  "settings.ongoingNotificationPermissionRequired": "Aviseringsbehörighet krävs",
  "settings.ongoingNotificationPreviewHint": "Förhandsvisning — slå på widgeten för att visa den",
  "settings.ongoingNotificationStatusBar": "Statusfält",
  "settings.polish": "polska",
  "settings.portuguese": "portugisiska",
  "settings.preferencesSection": "Preferenser",
  "settings.privacyPolicy": "Sekretesspolicy",
  "settings.russian": "ryska",
  "settings.serbian": "serbiska",
  "settings.settings": "Inställningar",
  "settings.settingsPageTitle": "Inställningar - {page}",
  "settings.slovak": "slovakiska",
  "settings.smallDecimals": "Små decimaler",
  "settings.smallDecimalsDescription": "Visa decimalsiffror i en mindre storlek",
  "settings.spanish": "spanska",
  "settings.statusBarWidget": "Statusfältswidget",
  "settings.statusBarWidgetDescription": "Alltid synliga väderdata",
  "settings.subscriptionSection": "Prenumeration",
  "settings.supportSection": "Support",
  "settings.swedish": "svenska",
  "settings.systemTheme": "Systemtema",
  "settings.termsOfService": "Användarvillkor",
  "settings.themeDarkShort": "Mörkt",
  "settings.themeLightShort": "Ljust",
  "settings.themeSystemShort": "System",
  "settings.turkish": "turkiska",
  "settings.ukrainian": "ukrainska",
  "settings.units": "Enheter",
  "settings.unitsDescription": "Måttenheter som visas i appen",
  "settings.update": "Uppdatera",
  "settings.windDirectionConvention": "Vindriktningspil",
  "settings.windDirectionConventionDescription": "Välj hur vindriktningspilar visas",
  "settings.windDirectionMeteorological": "Ursprungsriktning",
  "settings.windDirectionMeteorologicalDescription": "Pilen visar varifrån vinden kommer (meteorologisk konvention)",
  "settings.windDirectionOceanographic": "Strömningsriktning",
  "settings.windDirectionOceanographicDescription": "Pilen visar vart vinden blåser (oceanografisk konvention)",
  "stations.addAStation": "Lägg till station",
  "stations.addToFavorites": "Lägg till i Favoriter",
  "stations.addYourOwnStation": "Lägg till din egen station",
  "stations.clearRecentLocations": "Rensa alla",
  "stations.clearSearch": "Rensa sökning",
  "stations.currentLocation": "Nuvarande plats",
  "stations.customizedStationName": "Anpassat stationsnamn",
  "stations.favoriteLocations": "Favoriter",
  "stations.favoriteLocationsEmpty": "Du kan lägga till upp till 5 favoritplatser.",
  "stations.favoriteStations": "Favoritstationer",
  "stations.filterStationDescription": "Visa inte stationer med opålitliga data",
  "stations.filterStations": "Filtrera stationer",
  "stations.filterStationSourceDescription": "Välj stationsleverantörer som du vill visa på kartan",
  "stations.findStationsNearYou": "Hitta stationer nära dig",
  "stations.hiddenStations": "Dolda stationer",
  "stations.hiddenStationsDescription": "Du kan visa en dold station igen genom att trycka på ögonikonen bredvid den.",
  "stations.hideStationNamed": "Dölj {station}",
  "stations.lastSeen": "senast {time}",
  "stations.loadingStation": "Läser in station…",
  "stations.location": "Plats",
  "stations.locationAddedToFavorites": "Plats tillagd till favoriter",
  "stations.locationNotGranted": "Platstillstånd beviljas inte. Tillåt åtkomst till din plats i enhetsinställningar.",
  "stations.locationRemovedFromFavorites": "Plats borttagen från favoriter",
  "stations.locations": "Platser",
  "stations.locationUnavailable": "Det gick inte att hämta din plats. Kontrollera enhetens inställningar.",
  "stations.maxFavoriteLocationsReached": "Du kan bara ha upp till 5 favoritplatser. Ta bort en för att lägga till en annan.",
  "stations.modifyFavoriteStations": "Ändra favoritstationer",
  "stations.modifyFavoriteStationsDescription": "Du kan ordna om dina favoritstationer genom att dra dem. Du kan också ta bort dem från listan.",
  "stations.myLocation": "Min plats",
  "stations.nearbyWeatherStations": "Närliggande väderstationer",
  "stations.noLocationsFound": "Inga platser hittades",
  "stations.noLongerReported": "Inte längre listad",
  "stations.noLongerReportedBy": "Inte längre listad hos {provider} sedan {date}",
  "stations.noSearchResults": "Inga artiklar matchar din sökning",
  "stations.noStationsFound": "Inga stationer hittades",
  "stations.noWeatherStationYet": "Du har ingen väderstation än.",
  "stations.recentLocations": "Senaste",
  "stations.recentLocationsEmpty": "Din historik är tom.",
  "stations.removeFromFavorites": "Ta bort från favoriter",
  "stations.removeStationNamed": "Ta bort {station} från favoriter",
  "stations.reorderStationNamed": "Flytta {station}",
  "stations.searchForLocation": "Sök plats",
  "stations.searchForWeatherStation": "Sök en väderstation",
  "stations.searchResults": "Sökresultat",
  "stations.searchResultsEmpty": "Inga resultat hittades.",
  "stations.searchResultsFound": "{count, plural, one {# resultat hittades} other {# resultat hittades}}",
  "stations.searchStationsDescription": "Ange en stad, adress eller platsnamn för att hitta väderstationer i närheten.",
  "stations.searchStationsHint": "Använd sökfältet ovan för att upptäcka väderstationer var som helst i världen.",
  "stations.selectStationForComparison": "Välj station för jämförelse",
  "stations.stationAddedToFavorites": "Station tillagd till favoriter",
  "stations.stationCount": "{count, plural, one {# station} other {# stationer}}",
  "stations.stationInformation": "Stationsinformation",
  "stations.stationName": "Stationens namn",
  "stations.stationObservationsDescription": "Visa de senaste observationerna från väderstationer",
  "stations.stationRemovedFromFavorites": "Stationen borttagen från favoriter",
  "stations.stationsLoading": "Läser in väderstationer",
  "stations.stationsNear": "Stationer nära {place}",
  "stations.stationType": "Stationstyp",
  "stations.statusOffline": "Offline",
  "stations.statusOnline": "Online",
  "stations.statusStale": "Föråldrad",
  "stations.tryAnotherLocation": "Vi kunde inte hitta några väderstationer nära denna plats. Försök söka i ett annat område.",
  "stations.unhideStationNamed": "Visa {station} igen",
  "stations.weatherStation": "Väderstation",
  "stations.weatherStationCount": "{count, plural, one {# väderstation} other {# väderstationer}}",
  "stations.weatherStations": "Väderstationer",
  "stations.welcomeConnectService": "Äger du en väderstation? Anslut din tjänst",
  "stations.welcomeSubtitle": "Ditt väder, allt på ett ställe",
  "thermostat.away": "Borta",
  "thermostat.boilerOn": "Värme på",
  "thermostat.hg": "Frostvakt",
  "thermostat.homeInformation": "Heminformation",
  "thermostat.homeName": "Hemmets namn",
  "thermostat.manualBoost": "Manuell boost",
  "thermostat.manualSetpointUntil": "Manuellt börvärde till",
  "thermostat.noThermostatYet": "Du har inte Netatmo termostat",
  "thermostat.relay": "Relä",
  "thermostat.room": "Rum",
  "thermostat.rooms": "Rum",
  "thermostat.smartThermostat": "Smart termostat",
  "thermostat.smartValve": "Smart ventil",
  "thermostat.whenBackHome": "När kommer du hem?",
  "units.celsius": "Celsius",
  "units.fahrenheit": "Fahrenheit",
  "units.inch": "Tum",
  "units.inchOfMercury": "Tum kvicksilver",
  "units.kelvin": "Kelvin",
  "units.kilometerPerHour": "Kilometer per timme",
  "units.knot": "Knop",
  "units.meterPerSecond": "Meter per sekund",
  "units.milePerHour": "Miles per timme",
  "units.millibar": "Millibar",
  "units.millimeter": "Millimeter",
  "units.millimeterOfMercury": "Millimeter kvicksilver",
  "weatherConditions.blizzard": "Snöstorm",
  "weatherConditions.blowingDust": "Yrande damm",
  "weatherConditions.blowingSnow": "Yrsnö",
  "weatherConditions.breezy": "Lätt blåst",
  "weatherConditions.clear": "Klart",
  "weatherConditions.cloudy": "Mulet",
  "weatherConditions.drizzle": "Duggregn",
  "weatherConditions.flurries": "Lätt snöfall",
  "weatherConditions.foggy": "Dimma",
  "weatherConditions.freezingDrizzle": "Underkylt duggregn",
  "weatherConditions.freezingRain": "Underkylt regn",
  "weatherConditions.frigid": "Bitande kyla",
  "weatherConditions.hail": "Hagel",
  "weatherConditions.haze": "Disigt",
  "weatherConditions.heavyRain": "Kraftigt regn",
  "weatherConditions.heavySnow": "Kraftigt snöfall",
  "weatherConditions.hot": "Hett",
  "weatherConditions.hurricane": "Orkan",
  "weatherConditions.isolatedThunderstorms": "Enstaka åskskurar",
  "weatherConditions.mixedRainAndHail": "Regn och hagel",
  "weatherConditions.mostlyClear": "Mestadels klart",
  "weatherConditions.mostlyCloudy": "Mestadels molnigt",
  "weatherConditions.mostlySunny": "Mestadels soligt",
  "weatherConditions.notAvailable": "Väderförhållanden ej tillgängliga",
  "weatherConditions.partlyCloudy": "Delvis molnigt",
  "weatherConditions.rain": "Regn",
  "weatherConditions.rainSleet": "Regn och iskorn",
  "weatherConditions.rainSnow": "Regn och snö",
  "weatherConditions.scatteredShowers": "Spridda skurar",
  "weatherConditions.scatteredSnowShowers": "Spridda snöbyar",
  "weatherConditions.scatteredThunderstorms": "Spridda åskskurar",
  "weatherConditions.showers": "Skurar",
  "weatherConditions.sleet": "Iskorn",
  "weatherConditions.smoke": "Rök",
  "weatherConditions.snow": "Snö",
  "weatherConditions.snowShowers": "Snöbyar",
  "weatherConditions.strongStorms": "Kraftiga åskskurar",
  "weatherConditions.sunny": "Soligt",
  "weatherConditions.thunderstorms": "Åskskurar",
  "weatherConditions.tornado": "Tornado",
  "weatherConditions.tropicalStorm": "Tropisk storm",
  "weatherConditions.windy": "Blåsigt",
  "weatherConditions.wintryMix": "Blandad vinternederbörd",
  "weatherMap.clusterMarkerName": "{metric} {value}, median av {count, plural, one {# station} other {# stationer}}, zooma in",
  "weatherMap.legendHeavy": "Kraftig",
  "weatherMap.legendLight": "Lätt",
  "weatherMap.legendLightningHelp": "Färgen visar varje blixtnedslags ålder under de senaste {minutes} minuterna — de nyaste i vitt, de äldsta i mörkrött.",
  "weatherMap.legendNewest": "Nyaste",
  "weatherMap.legendOldest": "Äldsta",
  "weatherMap.legendStationsHelp": "Markörens färg återspeglar värdet på det valda måttet.",
  "weatherMap.lightningDataAttribution": "Blixtdata: Blitzortung.org",
  "weatherMap.lightningStrikes": "Blixtnedslag",
  "weatherMap.lightningStrikesDescription": "Visa blixtnedslag i realtid på kartan",
  "weatherMap.mapLayers": "Kartlager",
  "weatherMap.mapLegend": "Kartteckenförklaring",
  "weatherMap.mapMode": "Kartläge",
  "weatherMap.mapNameForecast": "Prognoskarta, {model}, {variable}",
  "weatherMap.mapNameObservations": "Väderkarta, observationer",
  "weatherMap.modeForecast": "Prognos",
  "weatherMap.modeObservations": "Observationer",
  "weatherMap.radarDataAttribution": "Radardata: NOAA / EUMETNET OPERA via LibreWXR",
  "weatherMap.radarTime": "Radartid",
  "weatherMap.rainRadar": "Regnradar",
  "weatherMap.rainRadarDescription": "Visa regnradaröverlägg på kartan",
  "weatherMap.resetBearing": "Dra för att rotera kartan, klicka för att återställa norr uppåt",
  "weatherMap.showingForecast": "Visar prognos: {model}, {variable}",
  "weatherMap.signInForecastBody": "GFS-kartor är gratis med ett SmartMixin-konto. Fler modeller ingår i Premium.",
  "weatherMap.signInForecastTitle": "Logga in för att se prognoskartor",
  "weatherMap.stationMarkerName": "{metric} {value}, en station",
  "weatherMap.stationMarkersHint": "Piltangenterna flyttar mellan stationerna",
  "weatherMap.stationMarkerWindValue": "{speed}, från {direction}",
  "weatherMap.weatherflowNCRain": "NC Rain (Nearcast Rain)",
  "weatherMap.weatherflowNCRainDescription": "NC Rain är en extra datakälla som tillhandahålls via Tempest Weather System, som drivs av Nearcast Technology. NC Rain är en uppskattning av den genomsnittliga nederbördsackumuleringen runt din Tempest på grannskapsnivå",
  "weatherMap.weatherMap": "Väderkarta",
  "weatherMap.weatherMapMetaDescription": "SmartMixin erbjuder interaktiva väder- och radarkartor för väderförhållanden världen över.",
  "weatherMap.zoomIn": "Zooma in",
  "weatherMap.zoomOut": "Zooma ut",
  "weatherWarnings.activeNow": "Aktiva nu",
  "weatherWarnings.agencyMessage": "Meddelande från vädertjänsten",
  "weatherWarnings.areaCovered": "Berört område",
  "weatherWarnings.areaThisLocation": "{area} (den här platsen)",
  "weatherWarnings.areaYourStation": "{area} (din väderstation)",
  "weatherWarnings.badgeLabel": "{others, plural, =0 {Officiell vädervarning, {severity}: {hazard}} one {Officiell vädervarning, {severity}: {hazard}, och # till} other {Officiell vädervarning, {severity}: {hazard}, och # till}}",
  "weatherWarnings.badgeLabelUpcoming": "{others, plural, =0 {Kommande officiell vädervarning, {severity}: {hazard}} one {Kommande officiell vädervarning, {severity}: {hazard}, och # till} other {Kommande officiell vädervarning, {severity}: {hazard}, och # till}}",
  "weatherWarnings.crumb": "Officiella varningar",
  "weatherWarnings.emptyBody": "Den nationella vädertjänsten har ingen gällande varning för den här platsen. Vi kontrollerar igen med några minuters mellanrum.",
  "weatherWarnings.emptyTitle": "Inga officiella varningar",
  "weatherWarnings.ended": "Upphört",
  "weatherWarnings.endedAt": "Den här varningen upphörde {time}.",
  "weatherWarnings.errorBody": "Kontrollera din anslutning. Vi försöker igen med några minuters mellanrum.",
  "weatherWarnings.errorTitle": "Det gick inte att läsa in officiella varningar",
  "weatherWarnings.fromTime": "Från {time}",
  "weatherWarnings.hazardAirQuality": "Luftkvalitet",
  "weatherWarnings.hazardAvalanche": "Laviner",
  "weatherWarnings.hazardCoastalEvent": "Kustfaror",
  "weatherWarnings.hazardFlood": "Översvämningar",
  "weatherWarnings.hazardFog": "Dimma",
  "weatherWarnings.hazardForestFire": "Skogsbränder",
  "weatherWarnings.hazardHighTemperature": "Höga temperaturer",
  "weatherWarnings.hazardLowTemperature": "Låga temperaturer",
  "weatherWarnings.hazardOther": "Annan fara",
  "weatherWarnings.hazardRain": "Regn",
  "weatherWarnings.hazardSnowIce": "Snö och is",
  "weatherWarnings.hazardThunderstorm": "Åskskurar",
  "weatherWarnings.hazardUv": "UV-strålning",
  "weatherWarnings.hazardWind": "Vind",
  "weatherWarnings.hideHazards": "Dölj risker",
  "weatherWarnings.issuedBy": "Utfärdad av {sender}",
  "weatherWarnings.lastUpdate": "Senast uppdaterad: {time}",
  "weatherWarnings.mapLabel": "{count, plural, =1 {Karta över berört område: {area}.} other {Karta över de # berörda områdena. {area} är markerat.}}",
  "weatherWarnings.mapLabelNoHighlight": "{count, plural, =1 {Karta över berört område.} other {Karta över de # berörda områdena.}}",
  "weatherWarnings.mapUnavailable": "{count, plural, =1 {Kartan är inte tillgänglig. Området listas nedan.} other {Kartan är inte tillgänglig. De # områdena listas nedan.}}",
  "weatherWarnings.moreHazards": "+ {count} till: {hazards}",
  "weatherWarnings.notInLanguage": "Inte tillgänglig på {language}. Visas som vädertjänsten publicerade den.",
  "weatherWarnings.openOn": "Öppna på {site}",
  "weatherWarnings.otherAreas": "{count, plural, one {+ # annat område} other {+ # andra områden}}",
  "weatherWarnings.severityExtreme": "Extrem",
  "weatherWarnings.severityFrom": "{severity} från {time}",
  "weatherWarnings.severityMinor": "Lindrig",
  "weatherWarnings.severityModerate": "Måttlig",
  "weatherWarnings.severityNow": "{severity} nu",
  "weatherWarnings.severitySevere": "Allvarlig",
  "weatherWarnings.severityUntil": "{severity} till {time}",
  "weatherWarnings.showAllAreas": "{count, plural, one {Visa # område} other {Visa alla # områden}}",
  "weatherWarnings.showAllOnMap": "{count, plural, one {Visa # område på kartan} other {Visa alla # områden på kartan}}",
  "weatherWarnings.showHazards": "Visa risker",
  "weatherWarnings.showPeriods": "{count, plural, one {Visa # period} other {Visa alla # perioder}}",
  "weatherWarnings.source": "Källa: {source}",
  "weatherWarnings.spokenHazardOne": "{hazard}: {status}.",
  "weatherWarnings.spokenHazardTwo": "{hazard}: {first}, sedan {second}.",
  "weatherWarnings.spokenLabel": "{count, plural, one {# officiell vädervarning} other {# officiella vädervarningar}}. {hazards}",
  "weatherWarnings.spokenLabelArea": "{label} {area}.",
  "weatherWarnings.spokenPeriod": "{severity}: {range}",
  "weatherWarnings.title": "Officiella vädervarningar",
  "weatherWarnings.todayAt": "i dag kl. {time}",
  "weatherWarnings.tomorrow": "I morgon",
  "weatherWarnings.tomorrowAt": "i morgon kl. {time}",
  "weatherWarnings.upcoming": "Kommande",
  "weatherWarnings.viewAll": "Alla officiella varningar",
  "weatherWarnings.whatToDo": "Så här gör du"
}
